/* #104 (T-1085) Cat's Atelier WALL BUILDER, page v2 (overnight 2026-10-15 F01). Drives <ca-wall-builder> rendered by
 * sections/ca-wall-builder.liquid on /pages/cat-wall-builder only.
 *
 * Port of the approved selector prototype v2 (scratchpad/audits/t1085-builder-content-2026-10-11/06-SELECTOR-REDESIGN,
 * "perfect", Martin 2026-10-12) onto real data + the v1 multi-add pipeline (forked from assets/dpc-wall-builder.js, the
 * live Alto builder, which is NOT edited): formatMoney, fail-closed init + is-ready gate, live-region announcer,
 * cart:prepare-bundled-sections -> POST cart/add.js {items, sections, sections_url} -> cart:change {baseEvent:'variant:add'};
 * on a non-200 re-read via cart/update.js; only a 422 is worded as a stock refusal.
 *
 * What v2 adds over v1: two ways in (six ideas, incl. the 2- and 3-shelf ones = the MULTI-SHELF LOADER, and a TRUE blank
 * wall), tabs Shelf 1-3 / Steps / Review, collapsible choice rows that close to the picked value, copy choices from
 * Shelf 1, an in-page details panel (decision_facts ticks, size-following "Holds up to" from ca_max_load, spec_summary),
 * steps as a data-driven list of step products, and "replace your wall?" before an idea overwrites a changed wall.
 * Rulings: up to 3 shelves + steps; each part keeps its own options; price per part + running total = sum of live variant
 * prices; NO set discount; the drawing (engine v4 planFrozen, assets/ca-wall-builder-rules.js) caps at 5 steps / 3
 * shelves and the real count stays visible; never stack (engine). Shelf, never perch.
 * The add-to-basket path has never been executed against a real cart unattended: the F01 probe aborts every non-GET.
 */
(function () {
  'use strict';
  if (window.__cawbLoaded) return;
  window.__cawbLoaded = true;

  var MAX_SHELVES = 3, MAX_STEPS = 20;
  // ---------------------------------------------------------------- tracking (#104, Martin 2026-10-21; design
  // docs/reviews/2026-10-20-wall-builder-ga4-tracking-design.md, names shared with the #150 PDP: docs/analytics/
  // ga4-conventions.md). GA4 through the theme's consent-mode gtag, so consent applies as for every other event; if gtag
  // is not there yet the event is queued on dataLayer in the arguments form gtag.js drains (theme.liquid's RUM pattern).
  // Analytics never blocks or breaks the builder.
  function device() { return window.innerWidth <= 749 ? 'mobile' : 'desktop'; }
  function track(name, params) {
    try {
      var p = Object.assign({ device: device() }, params || {});
      if (typeof window.gtag === 'function') window.gtag('event', name, p);
      else { window.dataLayer = window.dataLayer || []; (function () { window.dataLayer.push(arguments); })('event', name, p); }
    } catch (e) { /* never */ }
  }
  function clarity(key, val) { try { if (typeof window.clarity === 'function') window.clarity('set', key, val); } catch (e) { /* never */ } }
  function sendError() { track('cawb_error'); clarity('cawb_stage', 'error'); }
  // option name -> the shared row vocabulary (first_open, row_name); anything else is snake_cased
  var ROW_SLUG = { 'Size': 'size', 'Dip': 'curve', 'Curve Shape': 'curve', 'Color': 'upper_fabric', 'Colour': 'upper_fabric', 'Base Fabric': 'base_fabric',
    'Wood Finish': 'wood_finish', 'Felt Colour': 'felt', 'Platform Colour': 'platform' };
  function rowSlug(k) { return ROW_SLUG[k] || String(k).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, ''); }
  // every basket line from the builder carries this hidden property, so Shopify orders can be counted exactly (the
  // underscore keeps it out of the basket, line-item.liquid)
  var SOURCE = { _source: 'wall-builder' };
  var TITLE_PREFIX = /^Floating Cat Wall Shelf\s*-\s*/i;
  // Swatch dots: the same hexes as snippets/cats-atelier-selectors.liquid. VALUES always come from the product data.
  var HEX = {
    'Grey': '#9a9a9a', 'Beige': '#c4b498', 'Cream': '#ede3cc', 'Dark Grey': '#454545', 'Chocolate': '#6a5754',
    'Dark Chocolate': '#6a5754', 'Bottle Green': '#2a5c3a', 'Deep Navy Blue': '#1a2444', 'Black': '#1a1a1a',
    'Brown': '#6b3a1f', 'Light Beige': '#e6dcc8', 'White': '#f5f5f2', 'Burgundy': '#6e1f2a', 'Cobalt Blue': '#1f4e9c',
    'Orange': '#d9692a', 'Caramel': '#c88040', 'Natural Pine': '#e4c99a', 'Natural Beech': '#d4a47a',
    'Golden Oak': '#b87830', 'Wenge': '#3c2a1a'
  };
  var NEUTRAL = '#d9d2c4';

  // ---------------------------------------------------------------- money (logic from dpc-wall-builder.js formatMoney)
  var MONEY_FORMAT = null;
  function formatMoney(cents) {
    var fmt = MONEY_FORMAT || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '£{{amount}}';
    var t = document.createElement('textarea');
    t.innerHTML = String(fmt).replace(/<[^>]*>/g, '');
    fmt = t.value;
    var value = Math.round(Number(cents) || 0);
    function delimit(precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = delimit(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': out = delimit(0, ' ', ''); break;
      case 'amount_with_space_separator': out = delimit(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = delimit(2, ' ', '.'); break;
      default: out = delimit(2, ',', '.');
    }
    return m ? fmt.replace(m[0], out) : out;
  }
  // whole pounds without ".00" (as money_without_trailing_zeros), pence kept otherwise
  function money(cents) { var s = formatMoney(cents); return value00(cents) ? s.replace(/[.,]00(?!\d)/, '') : s; }
  function value00(c) { return Math.round(c) % 100 === 0; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  // #104 redesign: what sits fixed at the top of the viewport = the theme header (--sticky-area-height is a calc(), 0
  // while the hide-on-scroll header is away, so it is RESOLVED through a fixed probe element) + the in-page nav once fixed.
  var topProbe = null;
  function headerH() {
    if (!topProbe) { topProbe = document.createElement('div'); topProbe.setAttribute('aria-hidden', 'true'); topProbe.style.cssText = 'position:fixed;left:0;width:0;height:0;visibility:hidden;pointer-events:none;top:var(--sticky-area-height,0px)'; document.body.appendChild(topProbe); }
    return topProbe.getBoundingClientRect().top || 0;
  }
  function navH() { var n = document.querySelector('[data-cawb-nav].is-stuck'); return n ? n.offsetHeight : 0; }
  function topOffset() { return headerH() + navH(); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  // Shopify image URLs carry ?width=N from image_url; swap it for the size we need
  function img(u, w) {
    if (!u) return '';
    var s = String(u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 400);
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function optOf(p, name) { return (p.options || []).filter(function (o) { return o.name === name; })[0]; }
  function minPrice(p) { return Math.min.apply(null, p.variants.map(function (v) { return v.price; })); }
  function qtyByVariant(cartJson) {
    var map = new Map();
    (cartJson && Array.isArray(cartJson.items) ? cartJson.items : []).forEach(function (l) {
      var vid = l.variant_id != null ? l.variant_id : l.id;
      map.set(vid, (map.get(vid) || 0) + (l.quantity || 0));
    });
    return map;
  }
  var TICK = '<svg class="cawb-tick" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2.5 7.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg class="cawb-row__chev" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  function init(rootEl) {
    var R = window.CaRules;
    if (!R) throw new Error('CaRules missing');
    MONEY_FORMAT = rootEl.getAttribute('data-money-format') || null;

    // ---------------------------------------------------------------- data (the section's live product JSON)
    var P = Array.prototype.map.call(rootEl.querySelectorAll('script[data-ca-wb-product]'), function (s) { return JSON.parse(s.textContent); });
    P.forEach(function (d) {
      d.name = String(d.title || '').replace(TITLE_PREFIX, '');
      var t = parseFloat(d.thick);
      d.thick = t > 0 ? t : (d.ca_type === 'cat shelf wood' ? 6 : 4);
      d.facts = Array.isArray(d.facts) ? d.facts : [];
      d.specs = Array.isArray(d.specs) ? d.specs : [];
      d.images = Array.isArray(d.images) && d.images.length ? d.images : (d.image ? [{ src: d.image, alt: '' }] : []);
    });
    var byHandle = {};
    P.forEach(function (p) { byHandle[p.handle] = p; });
    function toEngine(d) {
      return { handle: d.handle, title: d.title, status: 'ACTIVE', productType: d.ca_type, caType: null, options: d.options,
        variants: { nodes: d.variants.map(function (v) {
          return { id: String(v.id), sku: v.sku, title: v.title, price: (v.price / 100).toFixed(2), available: v.available,
            selectedOptions: v.options.map(function (val, i) { return { name: d.options[i] ? d.options[i].name : '', value: val }; }) };
        }) } };
    }
    var eligible = R.eligibleProducts(P.map(toEngine));
    var eng = {};
    eligible.forEach(function (e) { eng[e.handle] = e; });
    var SHELVES = eligible.filter(function (e) { return e.role === 'shelf'; }).map(function (e) { return byHandle[e.handle]; });
    // Steps are a LIST: every step product in the data, in data order (a second step product is one more list entry).
    var STEP_PRODUCTS = eligible.filter(function (e) { return e.role === 'step'; }).map(function (e) { return byHandle[e.handle]; });
    if (!SHELVES.length || !STEP_PRODUCTS.length) throw new Error('no shelves or no step product');
    var stepByHandle = {};
    STEP_PRODUCTS.forEach(function (s) { stepByHandle[s.handle] = s; });

    // ---------------------------------------------------------------- option helpers
    function isCombined(p) { var o = optOf(p, 'Size'); return !!(o && o.values.some(function (v) { return / - Dip /.test(v); })); }
    // a variant's options in UI terms (Playful Curve's "75cm - Dip Left" becomes Size 75cm + Dip Left, like The Wave)
    function uiOfVariant(p, v) {
      var ui = {};
      p.options.forEach(function (o, i) {
        var val = v.options[i];
        if (o.name === 'Size' && / - Dip /.test(val)) { ui.Size = val.split(' - ')[0]; ui.Dip = val.split(' - ')[1]; }
        else if (o.name === 'Curve Shape') ui.Dip = val;
        else ui[o.name] = val;
      });
      return ui;
    }
    function rowsFor(shelf) {
      var rows = [{ key: 'shelf', label: 'Shelf', kind: 'cards' }], fixed = [];
      if (!shelf.handle) return { rows: rows, fixed: fixed };
      var p = byHandle[shelf.handle], comb = isCombined(p);
      var so = optOf(p, 'Size');
      var sizes = so ? uniq(so.values.map(function (v) { return v.split(' - ')[0]; })) : [];
      if (sizes.length > 1) rows.push({ key: 'Size', label: 'Size', values: sizes });
      else if (sizes.length === 1) fixed.push({ key: 'Size', label: 'Size', value: sizes[0] + ' (one size)' });
      var dips = comb ? uniq(so.values.map(function (v) { return v.split(' - ')[1]; })) : (optOf(p, 'Curve Shape') || { values: [] }).values;
      if (dips.length > 1) rows.push({ key: 'Dip', label: 'Dip side', values: dips });
      p.options.forEach(function (o) {
        if (o.name === 'Size' || o.name === 'Curve Shape') return;
        var label = (o.name === 'Color' || o.name === 'Colour') ? (p.ca_type === 'cat shelf' ? 'Upper cushion fabric' : 'Cushion fabric') : (o.name === 'Wood Finish' ? 'Wood finish' : o.name);
        if (o.values.length > 1) rows.push({ key: o.name, label: label, values: o.values, swatch: true });
        else fixed.push({ key: o.name, label: label, value: o.values[0] });
        if ((o.name === 'Color' || o.name === 'Colour') && p.ca_type === 'cat shelf') {
          rows.push({ key: 'Base Fabric', label: 'Base fabric', values: R.BASE_FABRIC_VALUES, swatch: true, help: 'The base fabric is chosen separately from the upper cushion.' });
        }
      });
      return { rows: rows, fixed: fixed };
    }
    function shelfUiFull(shelf) {
      var ui = Object.assign({}, shelf.ui);
      rowsFor(shelf).fixed.forEach(function (f) { if (!ui[f.key]) ui[f.key] = f.value.replace(' (one size)', ''); });
      return ui;
    }
    function extraFixed(shelf, k) { return rowsFor(shelf).fixed.some(function (f) { return f.key === k; }); }
    function compatible(shelf, extra) {
      var p = byHandle[shelf.handle], ui = Object.assign(shelfUiFull(shelf), extra || {});
      var done = Object.assign({}, shelf.done, extra ? Object.keys(extra).reduce(function (o, k) { o[k] = true; return o; }, {}) : {});
      return p.variants.filter(function (v) {
        var vu = uiOfVariant(p, v);
        return Object.keys(vu).every(function (k) { return !done[k] && !extraFixed(shelf, k) ? true : vu[k] === ui[k]; });
      });
    }
    function shelfComplete(shelf) {
      if (!shelf.handle) return false;
      return rowsFor(shelf).rows.every(function (r) { return r.key === 'shelf' || shelf.done[r.key]; });
    }
    function shelfVariant(shelf) {
      if (!shelfComplete(shelf)) return null;
      var p = byHandle[shelf.handle], ui = shelfUiFull(shelf), opts = {};
      p.options.forEach(function (o) {
        if (o.name === 'Size') opts.Size = isCombined(p) ? ui.Size + ' - ' + ui.Dip : ui.Size;
        else if (o.name === 'Curve Shape') opts[o.name] = ui.Dip;
        else opts[o.name] = ui[o.name];
      });
      var ev = R.resolveVariant(eng[shelf.handle].product, opts);
      return ev ? p.variants.filter(function (v) { return String(v.id) === String(ev.id); })[0] : null;
    }
    function shelfPrice(shelf) {
      if (!shelf.handle) return { cents: Math.min.apply(null, SHELVES.map(minPrice)), from: true };
      var v = shelfVariant(shelf);
      if (v) return { cents: v.price, from: false };
      var c = compatible(shelf);
      return { cents: Math.min.apply(null, (c.length ? c : byHandle[shelf.handle].variants).map(function (x) { return x.price; })), from: true };
    }
    function shelfThumb(shelf) {
      if (!shelf.handle) return null;
      var v = shelfVariant(shelf);
      if (v && v.thumb) return v.thumb;
      var c = compatible(shelf).filter(function (x) { return x.thumb; });
      // #104 v16: a wood finish chosen before the colour shows a photo of that finish too
      var picDone = Object.keys(shelf.done).some(function (k) { return shelf.done[k] && isPicKey(k); });
      return picDone && c.length ? c[0].thumb : byHandle[shelf.handle].image;
    }
    function isColourKey(k) { return k === 'Color' || k === 'Colour'; }
    // #104 v16 (Martin 2026-10-22): rows whose choice changes the shelf's photo get the big picture beside the options and
    // their own Next: the cushion fabric, and the wood finish (Cozy Nook, Softly Shaped, Wavey Retreat have a photo per finish)
    function isPicKey(k) { return isColourKey(k) || k === 'Wood Finish'; }
    // #104 review 6 (Martin 2026-10-21: "slow to change when amending colours"): measured 0.5-0.7s for a colour's first
    // showing on desktop wifi, as each photo was fetched only on the tap. While a colour row is open, every colour's
    // photo for that shelf is fetched ahead (one file each, 40-55KB as WebP at BIG_W, measured), so a tap shows it at once.
    var BIG_W = 640, bigShown = null, fetched = {};
    function preloadColours() {
      if (!/^shelf-/.test(S.tab)) return;
      var i = Number(S.tab.split('-')[1]), sh = S.shelves[i], key = sh && S.open[S.tab];
      if (!sh || !sh.handle || !isPicKey(key)) return;
      var row = rowsFor(sh).rows.filter(function (r) { return r.key === key; })[0];
      (row ? row.values : []).forEach(function (v) {
        var ui = Object.assign({}, sh.ui), done = Object.assign({}, sh.done);
        ui[key] = v; done[key] = true;
        var u = img(shelfThumb({ handle: sh.handle, ui: ui, done: done }), BIG_W);
        if (u && !fetched[u]) { fetched[u] = new Image(); fetched[u].src = u; }
      });
    }
    function shortSpec(shelf) {
      var ui = shelfUiFull(shelf), bits = [], rf = rowsFor(shelf);
      rf.rows.concat(rf.fixed).forEach(function (r) { if (r.key !== 'shelf' && r.key !== 'Base Fabric' && (shelf.done[r.key] || r.value) && ui[r.key]) bits.push(ui[r.key]); });
      return bits;
    }
    // "Holds up to": ca_max_load matched BY NUMBER to the chosen size (must-fix 18); whole text if unmatched; never guessed.
    function loadFor(p, size) {
      if (!p.maxLoad) return null;
      var segs = [], re = /(\d+\s*kg)\s*\(([^)]*)\)/g, m;
      while ((m = re.exec(p.maxLoad))) segs.push({ kg: m[1], sizes: m[2].match(/\d+/g) || [] });
      if (!segs.length) return p.maxLoad;
      var n = size ? String(size).match(/\d+/) : null;
      var hit = n ? segs.filter(function (s) { return s.sizes.indexOf(n[0]) > -1; })[0] : null;
      return hit ? hit.kg : p.maxLoad;
    }
    function dimsFor(p, size) {
      var d = (p.specs || []).filter(function (s) { return s.label === 'Dimensions'; })[0];
      if (!d) return null;
      var n = size ? String(size).match(/\d+/) : null, re = /(\d+) x (\d+) x (\d+) ?cm/g, m;
      while (n && (m = re.exec(d.value))) if (m[1] === n[0]) return m[1] + ' x ' + m[2] + ' x ' + m[3] + ' cm';
      return d.value;
    }

    // ---------------------------------------------------------------- state
    var S = { shelves: [], steps: [], stepShared: {}, perStep: false, tab: 'none', open: {}, idea: null, dirty: false, copyMsg: null, added: false };
    function blankShelf() { return { handle: null, ui: {}, done: {} }; }
    function realStep() { return STEP_PRODUCTS[0]; }
    function stepRows(sp) {
      return sp.options.filter(function (o) { return o.values.length > 1; }).map(function (o) {
        return { key: o.name, label: o.name === 'Felt Colour' ? 'Felt colour' : (o.name === 'Platform Colour' ? 'Platform colour' : o.name), values: o.values, swatch: true };
      });
    }
    function sharedFor(h) { if (!S.stepShared[h]) S.stepShared[h] = { ui: {}, done: {} }; return S.stepShared[h]; }
    function stepCount(h) { return S.steps.filter(function (s) { return s.handle === h; }).length; }
    function setStepCount(h, n) {
      n = Math.max(0, n);
      var others = S.steps.length - stepCount(h);
      n = Math.min(n, MAX_STEPS - others);
      var cur = stepCount(h);
      while (cur > n) { for (var i = S.steps.length - 1; i >= 0; i--) if (S.steps[i].handle === h) { S.steps.splice(i, 1); break; } cur--; }
      while (cur < n) { S.steps.push({ handle: h, ui: Object.assign({}, sharedFor(h).ui) }); cur++; }
    }
    function stepUi(st) { return S.perStep ? st.ui : sharedFor(st.handle).ui; }
    function stepsComplete() {
      return S.steps.every(function (st) {
        var sp = stepByHandle[st.handle], ui = stepUi(st);
        return stepRows(sp).every(function (r) { return S.perStep ? !!ui[r.key] : !!sharedFor(st.handle).done[r.key]; });
      });
    }
    function stepVariant(st) {
      var sp = stepByHandle[st.handle], ui = stepUi(st), opts = {};
      sp.options.forEach(function (o) { opts[o.name] = o.values.length === 1 ? o.values[0] : ui[o.name]; });
      if (sp.options.some(function (o) { return !opts[o.name]; })) return null;
      var ev = R.resolveVariant(eng[sp.handle].product, opts);
      return ev ? sp.variants.filter(function (v) { return String(v.id) === String(ev.id); })[0] : null;
    }

    // basket lines in route order (steps, then shelves 1-3), identical variant + properties merged
    function lines() {
      var out = [];
      function add(p, v, props, label) {
        var key = v.id + '|' + JSON.stringify(props || {});
        var hit = out.filter(function (l) { return l.key === key; })[0];
        if (hit) { hit.qty++; return; }
        out.push({ key: key, p: p, v: v, qty: 1, props: props, label: label });
      }
      S.steps.forEach(function (st) {
        var sp = stepByHandle[st.handle], v = stepVariant(st);
        if (v) add(sp, v, Object.assign({}, SOURCE), v.title.replace(/^One Size \/ /, ''));
      });
      S.shelves.forEach(function (sh) {
        var v = shelfVariant(sh);
        if (!v) return;
        var p = byHandle[sh.handle];
        var props = Object.assign(p.ca_type === 'cat shelf' ? { 'Base Fabric': sh.ui['Base Fabric'] } : {}, SOURCE);
        add(p, v, props, shortSpec(sh).join(', '));
      });
      return out;
    }
    function totals() {
      var cents = 0, from = false;
      S.shelves.forEach(function (sh) { var pr = shelfPrice(sh); cents += pr.cents; if (pr.from) from = true; });
      S.steps.forEach(function (st) {
        var sp = stepByHandle[st.handle], v = stepVariant(st);
        cents += v ? v.price : minPrice(sp);
        if (!v) from = true;
      });
      return { cents: cents, from: from };
    }
    function isEmpty() { return !S.shelves.length && !S.steps.length; }
    function todoList() {
      var t = [];
      if (isEmpty()) return [{ tab: 'none', row: null, text: 'Add a shelf or some steps' }];
      S.shelves.forEach(function (sh, i) {
        if (!sh.handle) { t.push({ tab: 'shelf-' + i, row: 'shelf', text: 'Shelf ' + (i + 1) + ': choose a shelf' }); return; }
        rowsFor(sh).rows.forEach(function (r) { if (r.key !== 'shelf' && !sh.done[r.key]) t.push({ tab: 'shelf-' + i, row: r.key, text: 'Shelf ' + (i + 1) + ': choose ' + r.label.toLowerCase() }); });
      });
      if (!stepsComplete()) t.push({ tab: 'steps', row: null, text: 'Steps: choose the step colours' });
      return t;
    }

    // ---------------------------------------------------------------- ideas (server-rendered cards; composition in data-*)
    var IDEAS = Array.prototype.map.call(rootEl.querySelectorAll('[data-cawb-idea]'), function (b) {
      return { id: b.getAttribute('data-cawb-idea'), el: b, name: (b.querySelector('.cawb-idea__name') || b).textContent.trim(),
        shelves: String(b.getAttribute('data-shelves') || '').split('|').filter(Boolean).map(function (x) { return x.split(':'); }),
        steps: Number(b.getAttribute('data-steps')) || 0 };
    }).filter(function (x) { return x.shelves.every(function (s) { return eng[s[0]] && eng[s[0]].role === 'shelf'; }); });
    function presetShelf(h, size) {
      var p = byHandle[h], d = R.defaultOptions(eng[h].product, size).options;
      var v = p.variants.filter(function (x) { return p.options.every(function (o, i) { return x.options[i] === d[o.name]; }); })[0] || p.variants[0];
      var sh = { handle: h, ui: uiOfVariant(p, v), done: {} };
      if (p.ca_type === 'cat shelf') sh.ui['Base Fabric'] = R.PROPERTY_DEFAULTS['Base Fabric'];
      rowsFor(sh).rows.forEach(function (r) { if (r.key !== 'shelf') sh.done[r.key] = true; });
      return sh;
    }
    function presetSteps(n) {
      var rs = realStep(), d = R.defaultOptions(eng[rs.handle].product).options, sh = sharedFor(rs.handle);
      stepRows(rs).forEach(function (r) { sh.ui[r.key] = d[r.key]; sh.done[r.key] = true; });
      setStepCount(rs.handle, n);
    }
    var pendingIdea = null;
    function applyIdea(id, force) {
      if (S.dirty && !force) { askReplace(id); return; }
      hideConfirm();
      var idea = id === 'blank' ? { blank: true } : IDEAS.filter(function (x) { return x.id === id; })[0];
      if (!idea) return;
      S.idea = id; S.dirty = false; S.open = {}; S.perStep = false; S.steps = []; S.stepShared = {}; S.copyMsg = null;
      el.toast.hidden = true;
      if (idea.blank) {
        S.shelves = []; // a TRUE blank: no shelves, no steps
      } else {
        S.shelves = idea.shelves.map(function (x) { return presetShelf(x[0], x[1]); });
        presetSteps(idea.steps);
        // #104 final review: an idea the shopper taps chooses AND completes its shelves, so it counts in the funnel
        // (shelf_chosen -> shelf_done), marked via=idea; a deep link or restored wall is still not counted (tracking off)
        if (tracking) S.shelves.forEach(function (sh, i) {
          track('cawb_shelf_chosen', { shelf_index: i, product_handle: sh.handle, via: 'idea' });
          if (once(doneKey(sh), 'cawb_shelf_done', { shelf_index: i, product_handle: sh.handle, via: 'idea' })) stage('shelf_done');
        });
      }
      S.tab = idea.blank ? 'none' : 'shelf-0';
      render();
      announce(idea.blank ? 'Blank wall. Nothing on it yet: add your first shelf or some steps.' : idea.name + ' loaded, with every choice filled in. Change anything you like.');
    }
    function askReplace(id) {
      pendingIdea = id;
      var idea = IDEAS.filter(function (x) { return x.id === id; })[0];
      el.confirmText.textContent = 'You have changed your wall. Replace it with ' + (id === 'blank' ? 'a blank wall' : idea ? idea.name : 'this idea') + '?';
      el.confirm.hidden = false; // one fixed place, under the idea cards
      el.confirmYes.focus({ preventScroll: true });
      el.confirm.scrollIntoView({ block: 'nearest' });
    }
    function hideConfirm() { pendingIdea = null; el.confirm.hidden = true; }
    IDEAS.forEach(function (x) {
      x.cents = x.shelves.reduce(function (t, s) { return t + shelfPrice(presetShelf(s[0], s[1])).cents; }, 0) + x.steps * minPrice(realStep());
    });

    // ---------------------------------------------------------------- dom refs
    function $(s) { return rootEl.querySelector(s); }
    var el = { blank: $('[data-cawb-blank]'), source: $('[data-cawb-source]'), tabsWrap: $('[data-cawb-tabs-wrap]'), empty: $('[data-cawb-empty]'),
      tablist: $('[data-cawb-tablist]'), panels: $('[data-cawb-panels]'), svg: $('[data-cawb-svg]'), stage: $('[data-cawb-stage]'),
      overflow: $('[data-cawb-overflow]'), total: $('[data-cawb-total]'), totalLabel: $('[data-cawb-total-label]'), count: $('[data-cawb-count]'),
      status: $('[data-cawb-status]'), wall: $('[data-cawb-wall]'), buybar: $('[data-cawb-buybar]'), barAdd: $('[data-cawb-buybar] [data-addall]'), drawer: $('[data-cawb-drawer]'), drawerBody: $('[data-cawb-drawer-body]'),
      toast: $('[data-cawb-toast]'), confirm: $('[data-cawb-confirm]'), confirmText: $('[data-cawb-confirm-text]'),
      confirmYes: $('[data-cawb-confirm-yes]'), confirmNo: $('[data-cawb-confirm-no]'), planner: rootEl.querySelector('#planner'), reset: $('[data-cawb-reset]') };
    var focusAfter = null, lastPointer = false, adding = false;
    rootEl.addEventListener('pointerdown', function () { lastPointer = true; }, true);
    rootEl.addEventListener('keydown', function () { lastPointer = false; }, true);
    function announce(msg) { el.status.textContent = ''; setTimeout(function () { el.status.textContent = msg; }, 30); }
    var toastT;
    var undoFn = null;
    function toast(msg, undo, ms) {
      undoFn = undo || null;
      el.toast.innerHTML = esc(msg) + (undo ? ' <button type="button" class="cawb-toast__undo" data-undo>Undo</button>' : '');
      el.toast.hidden = false; clearTimeout(toastT);
      toastT = setTimeout(function () { el.toast.hidden = true; undoFn = null; }, ms || (undo ? 8000 : 4200));
      announce(msg + (undo ? ' Undo is available.' : ''));
      // keyboard and screen-reader shoppers land on Undo, so they can reach it before it goes (final review)
      var u = undo && el.toast.querySelector('[data-undo]'); if (u) u.focus({ preventScroll: true });
    }
    // #104 final review: a basket problem is SEEN, not only read out (it used to reach screen readers alone)
    function problem(msg) { toast(msg, null, 9000); }
    function markDirty() { S.dirty = true; S.added = false; startOnce('choice'); }
    // #104 redesign point 5: the primary button names the shopper's REAL next action. Every stage complete -> "Review my
    // wall" (wherever they are, including after editing a finished shelf); otherwise the first open choice in a later
    // tab, else the first open choice anywhere, else simply the next tab.
    function tabLabel(id) { return id === 'steps' ? 'Steps' : id === 'review' ? 'Review' : id === 'none' ? 'Your wall' : 'Shelf ' + (Number(id.split('-')[1]) + 1); }
    function nextAction(fromId) {
      var todo = isEmpty() ? [] : todoList();
      if (!isEmpty() && !todo.length) return { id: 'review', row: '', label: nextLabel('review') };
      var ids = tabIds(), i = ids.indexOf(fromId);
      var t = todo.filter(function (x) { return ids.indexOf(x.tab) > i; })[0] || todo.filter(function (x) { return x.tab !== fromId; })[0];
      if (t) return { id: t.tab, row: t.row || '', label: nextLabel(t.tab) };
      var nid = ids[i + 1] || 'review';
      return { id: nid, row: '', label: nextLabel(nid) };
    }
    function nextLabel(id) { return id === 'steps' ? 'Next: choose steps' : id === 'review' ? 'Next: review my wall' : 'Next: ' + tabLabel(id); }
    function outlineBtn(attrs, text) { return '<button type="button" class="cawb-btn cawb-btn--outline" ' + attrs + '>' + esc(text) + '</button>'; }
    var XICON = '<svg class="cawb-x__icon" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M3 3l8 8M11 3l-8 8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    // the x sits on the CURRENT shelf only (Martin 2026-10-20): a 44px target that never lands where a tap meant to
    // switch shelves would, and a row of chips that still fits a phone. Undo follows every removal.
    function removeX(i) {
      return '<button type="button" class="cawb-x" data-remove="' + i + '" aria-label="Remove Shelf ' + (i + 1) + '">' + XICON + '</button>';
    }
    function nextBtn(fromId) {
      var a = nextAction(fromId);
      return '<button type="button" class="cawb-btn cawb-btn--dark" data-next="' + a.id + '" data-nextrow="' + esc(a.row) + '">' + esc(a.label) + '</button>';
    }

    // ---------------------------------------------------------------- tabs
    function tabIds() { return S.shelves.map(function (_, i) { return 'shelf-' + i; }).concat(['steps', 'review']); }
    // #104 review 2026-10-20 (Martin chose option A): the strip is always Shelves / Steps / Review, so Steps and Review
    // never leave the screen; the shelves are chips inside the Shelves panel, with "+ Add a shelf" beside them. Phone
    // first; the same on desktop since Martin's later review the same day (equal boxed tabs, no add button in the row).
    // The per-shelf tab code below is kept for PHONE_TABS = false.
    var PHONE_TABS = true;
    function compact() { return PHONE_TABS; }
    function shelvesTab() {
      if (/^shelf-/.test(S.tab)) return S.tab;
      if (S.lastShelf && S.shelves[Number(S.lastShelf.split('-')[1])]) return S.lastShelf;
      return S.shelves.length ? 'shelf-0' : 'none';
    }
    function stripIds() { return compact() ? [shelvesTab(), 'steps', 'review'] : tabIds(); }
    function stripKey(id) { return compact() && /^shelf-/.test(id) ? 'shelves' : id; }
    function tabBtn(id, thumb, name, state, extra) {
      var key = stripKey(id), on = key === 'shelves' ? /^shelf-/.test(S.tab) : S.tab === id;
      return '<button type="button" role="tab" class="cawb-tab' + (thumb ? '' : ' cawb-tab--noimg') + '" id="cawb-tab-' + key + '" aria-controls="cawb-panel-' + id + '" aria-selected="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-tab="' + id + '">' +
        thumb + '<span class="cawb-tab__name">' + esc(name) + (extra ? '<span class="cawb-sr">, ' + esc(extra) + '</span>' : '') + '</span>' + state + '</button>';
    }
    function shelfChips() {
      if (!compact()) return '';
      var h = '<div class="cawb-chips" role="group" aria-label="Your shelves">';
      S.shelves.forEach(function (sh, i) {
        var id = 'shelf-' + i, done = shelfComplete(sh);
        h += '<button type="button" class="cawb-chip" data-tab="' + id + '" aria-current="' + (S.tab === id) + '">' + (done ? TICK : '') + 'Shelf ' + (i + 1) +
          (sh.handle ? '<span class="cawb-sr">, ' + esc(byHandle[sh.handle].name) + (done ? ', done' : '') + '</span>' : '') + '</button>';
        if (S.tab === id) h += removeX(i);
      });
      if (S.shelves.length < MAX_SHELVES) h += '<button type="button" class="cawb-chip cawb-chip--add" data-add-shelf>+ Add a shelf</button>';
      return h + '</div>';
    }
    function renderTabs() {
      var h = '';
      el.tablist.classList.toggle('cawb-tabs__list--three', compact());
      if (compact()) {
        var n = S.shelves.length, nd = S.shelves.filter(shelfComplete).length;
        h += tabBtn(shelvesTab(), '', 'Shelves', '<span class="cawb-tab__state' + (n && nd === n ? ' cawb-tab__state--done">' + TICK + n + (n === 1 ? ' shelf' : ' shelves') :
          '">' + (n ? nd + ' of ' + n + ' done' : 'None yet')) + '</span>', '');
      } else S.shelves.forEach(function (sh, i) {
        var id = 'shelf-' + i, done = shelfComplete(sh), th = shelfThumb(sh);
        var left = sh.handle ? rowsFor(sh).rows.filter(function (r) { return r.key !== 'shelf' && !sh.done[r.key]; }).length : null;
        var state = done ? '<span class="cawb-tab__state cawb-tab__state--done">' + TICK + 'Done</span>' :
          '<span class="cawb-tab__state">' + (sh.handle ? left + ' to choose' : 'Choose a shelf') + '</span>';
        h += tabBtn(id, th ? '<img class="cawb-tab__img" src="' + esc(img(th, 120)) + '" alt="" width="40" height="40">' : '<span class="cawb-tab__img cawb-tab__img--empty" aria-hidden="true">+</span>',
          'Shelf ' + (i + 1), state, sh.handle ? byHandle[sh.handle].name : '');
        if (S.tab === id) h += removeX(i);
      });
      if (!compact() && S.shelves.length < MAX_SHELVES) h += '<button type="button" class="cawb-tab-add" data-add-shelf>' + (S.shelves.length ? '+ Add a shelf' : '+ Add your first shelf') + '</button>';
      var sDone = stepsComplete();
      h += tabBtn('steps', compact() ? '' : '<img class="cawb-tab__img" src="' + esc(img(realStep().image, 120)) + '" alt="" width="40" height="40">', 'Steps',
        !S.steps.length ? '<span class="cawb-tab__state">None yet</span>' : sDone ? '<span class="cawb-tab__state cawb-tab__state--done">' + TICK + S.steps.length + (S.steps.length === 1 ? ' step' : ' steps') + '</span>' : '<span class="cawb-tab__state">Colours to choose</span>', '');
      var t = totals(), todo = isEmpty() ? 0 : todoList().length;
      h += tabBtn('review', '', 'Review', '<span class="cawb-tab__state' + (todo || isEmpty() ? '' : ' cawb-tab__state--done') + '">' + (isEmpty() ? 'Nothing yet' : todo ? todo + ' left' : TICK + 'Ready') + '</span>', t.from ? 'total from ' + money(t.cents) : 'total ' + money(t.cents));
      el.tablist.innerHTML = h;
    }
    el.tablist.addEventListener('keydown', function (e) {
      var cur = e.target.closest('[role=tab]'), ids = stripIds(), i = ids.indexOf(cur ? cur.getAttribute('data-tab') : S.tab), n = null;
      if (e.key === 'ArrowRight') n = ids[(i + 1) % ids.length];
      else if (e.key === 'ArrowLeft') n = ids[(i - 1 + ids.length) % ids.length];
      else if (e.key === 'Home') n = ids[0];
      else if (e.key === 'End') n = ids[ids.length - 1];
      if (n) { e.preventDefault(); goTab(n, true); }
    });
    function goTab(id, focusTab, row) {
      S.tab = id; S.copyMsg = null; el.toast.hidden = true;
      if (/^shelf-/.test(id)) S.lastShelf = id;
      if (row !== undefined) S.open[id] = row;
      render();
      var t = document.getElementById('cawb-tab-' + stripKey(id));
      if (t) {
        try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { /* old browsers */ }
        if (focusTab) t.focus({ preventScroll: true });
      }
      var r = row ? document.getElementById('cawb-rowbtn-' + id + '-' + String(row).replace(/\s/g, '_')) : null;
      if (r) { r.scrollIntoView({ block: 'start' }); r.focus({ preventScroll: true }); }
      else if (!focusTab) toSelections();
      // #104 final review: the button pressed was re-rendered away; keyboard focus goes to the new panel, not the page top
      if (!r && focusLost()) { var pn = document.getElementById('cawb-panel-' + id); if (pn) pn.focus({ preventScroll: true }); }
    }
    function focusLost() { var a = document.activeElement; return !a || a === document.body || a === document.documentElement || !document.contains(a); }
    function focusTab() { var t = document.getElementById('cawb-tab-' + stripKey(S.tab)); if (t) t.focus({ preventScroll: true }); }
    // #104 review 7 (Martin 2026-10-21): a Next with no question to open ("Next: choose steps", "Next: review my wall")
    // goes back to the top of the selections. Phone/tablet (tabs stick): the panel starts right under the menu + tabs.
    // Desktop: the planner (drawing + tabs) at the top, as after a tapped answer. One instant correction once the smooth
    // scroll and the theme header's slide have settled.
    function toSelections() {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var place = function (smooth) {
        var phone = window.innerWidth < 1000, nav = document.querySelector('[data-cawb-nav]');
        var t = phone ? el.panels : ((el.planner && el.planner.querySelector('.cawb-planner__grid')) || el.panels);
        var base = (nav ? nav.offsetHeight : 0) + (phone ? stripH() + el.tabsWrap.offsetHeight : 8);
        var top = t.getBoundingClientRect().top;
        if (Math.abs(top - (headerNow() + base)) <= 2) return;
        var up = top < headerNow() + base;
        window.scrollTo({ top: window.scrollY + top - ((up ? headerFull() : 0) + base), behavior: smooth ? 'smooth' : 'auto' });
      };
      place(!reduce);
      clearTimeout(scrollFixT);
      scrollFixT = setTimeout(function () { place(false); }, reduce ? 50 : 700);
    }
    // the phone drawing only counts as a pinned strip while the CSS pins it (unpinned since 2026-10-20)
    function stripH() { return window.innerWidth < 1000 && /sticky|fixed/.test(getComputedStyle(el.wall).position) ? el.wall.offsetHeight : 0; }

    // ---------------------------------------------------------------- panels
    function showEmpty() { return isEmpty() && S.tab !== 'steps' && S.tab !== 'review'; }
    function renderPanels() {
      var h = '';
      el.tabsWrap.hidden = showEmpty();
      if (showEmpty()) {
        el.panels.innerHTML = '<div class="cawb-empty"><h3 class="cawb-panel__title">Add your first piece</h3>' +
          '<p class="cawb-panel__meta">Add pieces one at a time. The drawing and the total update as you go. Our planning tip: start from the floor.</p>' +
          '<div class="cawb-empty__acts"><button type="button" class="cawb-btn cawb-btn--dark" data-add-shelf>Add your first shelf</button>' +
          '<button type="button" class="cawb-btn" data-add-steps>Add steps</button></div></div>';
        bigShown = null;
        return;
      }
      // #104 final review: steps but no shelf yet (or the last shelf removed): the Shelves tab still has somewhere to go
      if (S.tab === 'none') h += '<div class="cawb-panel" role="tabpanel" id="cawb-panel-none" aria-labelledby="cawb-tab-none" tabindex="-1">' +
        '<p class="cawb-panel__meta">No shelves yet. Add one for your cat to climb up to.</p>' + shelfChips() + '</div>';
      tabIds().forEach(function (id) {
        var on = id === S.tab;
        h += '<div class="cawb-panel" role="tabpanel" id="cawb-panel-' + id + '" aria-labelledby="cawb-tab-' + stripKey(id) + '"' + (on ? '' : ' hidden') + ' tabindex="-1">';
        if (on) h += id === 'steps' ? stepsPanel() : (id === 'review' ? reviewPanel() : shelfPanel(Number(id.split('-')[1])));
        h += '</div>';
      });
      el.panels.innerHTML = h;
      bigShown = el.panels.querySelector('[data-cawb-bigpic]') ? S.tab : null; // grows only on the render that opens it
      preloadColours();
    }
    function firstOpen(id, rows, doneMap) {
      if (S.open[id] !== undefined) return S.open[id];
      var r = rows.filter(function (x) { return !doneMap[x.key]; })[0];
      S.open[id] = r ? r.key : null;
      return S.open[id];
    }
    function rk(k) { return String(k).replace(/\s/g, '_'); }
    function shelfPanel(i) {
      var sh = S.shelves[i], id = 'shelf-' + i, rf = rowsFor(sh), p = sh.handle ? byHandle[sh.handle] : null;
      var doneMap = Object.assign({ shelf: !!sh.handle }, sh.done);
      var open = firstOpen(id, rf.rows, doneMap);
      var pr = shelfPrice(sh), th = shelfThumb(sh), ui = shelfUiFull(sh);
      var sizeKnown = sh.done.Size || rf.fixed.some(function (f) { return f.key === 'Size'; });
      // while the colour row is open the small picture uses the big one's file, so a colour change fetches one photo
      var big = !!p && isPicKey(open);
      var h = '', colourNext = null;
      h += shelfChips();
      // v17: --big hides this small copy of the photo while the big picture shows the same shelf (from 750px)
      // v18 (Martin 2026-10-23, "one-line head"): --chosen makes it one line with no photo from 1000px
      h += '<div class="cawb-panel__head' + (big && th ? ' cawb-panel__head--big' : '') + (p ? ' cawb-panel__head--chosen' : '') + '">' + (th ? '<img class="cawb-panel__img" src="' + esc(img(th, big ? BIG_W : 240)) + '" alt="' + esc(p ? p.name + ', as chosen so far' : '') + '" width="88" height="88">' :
        '<div class="cawb-panel__img cawb-panel__img--empty">Shelf ' + (i + 1) + '</div>') + '<div>';
      h += '<h3 class="cawb-panel__title">' + (p ? 'Shelf ' + (i + 1) + ': ' + esc(p.name) : 'Shelf ' + (i + 1)) + '</h3>';
      h += '<p class="cawb-panel__price">' + (pr.from ? 'from ' : '') + money(pr.cents) + '</p>';
      if (p) {
        var load = loadFor(p, sizeKnown ? ui.Size : null);
        if (load && (sizeKnown || !/\(/.test(p.maxLoad))) h += '<p class="cawb-panel__meta">Holds up to ' + esc(load) + '</p>';
        h += '<button type="button" class="cawb-link" data-details="' + esc(p.handle) + '" data-for="' + i + '">Photos and full details</button>';
      } else h += '<p class="cawb-panel__meta">Pick a shelf below. The drawing updates as you choose.</p>';
      h += '</div></div>';
      if (i > 0 && S.shelves[0].handle) {
        h += '<div class="cawb-panel__copy"><span>Want it to match?</span><button type="button" class="cawb-btn" data-copy="' + i + '">Copy choices from Shelf 1</button>' +
          (S.copyMsg && S.copyMsg.i === i ? '<p class="cawb-panel__copymsg" role="status" data-cawb-copymsg>' + esc(S.copyMsg.text) + '</p>' : '') + '</div>';
      }
      // unstyled-list: Prestige forces every list item's top margin to 0 (theme.css :where(ol, ul):not(.unstyled-list) li,
      // !important), which ate the chips' gaps on Test (v18 Y2)
      h += '<ul class="cawb-rows unstyled-list">';
      rf.rows.forEach(function (r) {
        var done = !!doneMap[r.key], isOpen = open === r.key;
        var val = r.key === 'shelf' ? (p ? p.name : '') : (done ? sh.ui[r.key] : '');
        // v17 (design review): an answered question that is not open is drawn as a chip, so the answers sit on one line
        // above the open question; the same button reopens it
        h += '<li class="cawb-row' + (done ? ' cawb-row--done' : '') + (done && !isOpen ? ' cawb-row--chip' : '') + '"><h4 class="cawb-row__h"><button type="button" class="cawb-row__btn" id="cawb-rowbtn-' + id + '-' + rk(r.key) + '" aria-expanded="' + isOpen + '" aria-controls="cawb-rowbody-' + id + '-' + rk(r.key) + '" data-row="' + esc(r.key) + '">' +
          '<span class="cawb-row__mark" aria-hidden="true">' + (done ? TICK : '') + '</span><span class="cawb-row__label">' + esc(r.label) + '</span>' +
          '<span class="cawb-row__value' + (done ? '' : ' cawb-row__value--todo') + '">' + (done ? esc(val) + '<span class="cawb-sr">, chosen</span>' : 'Not chosen') + CHEV + '</span></button></h4>';
        h += '<div class="cawb-row__body" id="cawb-rowbody-' + id + '-' + rk(r.key) + '"' + (isOpen ? '' : ' hidden') + '>';
        if (r.help) h += '<p class="cawb-row__help">' + esc(r.help) + '</p>';
        var opts = r.key === 'shelf' ? shelfCards(i, sh) : optGroup('cawb-s' + i + '-' + rk(r.key), r, done ? sh.ui[r.key] : null, function (v) {
          if (r.key !== 'Size') return '';
          var c = compatible(sh, { Size: v });
          return c.length ? money(Math.min.apply(null, c.map(function (x) { return x.price; }))) : '';
        }, 'data-shelf="' + i + '"');
        // #104 review 6 (Martin's idea, 2026-10-21): while the colour row is open the shelf picture grows beside the
        // colours (above them on a phone) and changes with every tap; a Next button moves on.
        if (isOpen && big && r.key === open && th) {
          var nk = nextOpen(id, rf.rows, doneMap, r.key);
          // #104 v16: nextOpen wraps round to this same row when it is the last one left ("Next: wood finish" under Wood
          // finish); then the button moves on to the next tab instead
          if (nk === r.key) nk = null;
          var nr = nk ? rf.rows.filter(function (x) { return x.key === nk; })[0] : null;
          h += '<div class="cawb-colour"><img class="cawb-bigpic' + (bigShown !== id ? ' is-grow' : '') + '" data-cawb-bigpic src="' + esc(img(th, BIG_W)) + '" alt="' +
            esc(p.name + (done ? ' in ' + sh.ui[r.key] : '')) + '" width="320" height="320">';
          // v19 (Martin 2026-10-23): when this row's answer finishes the shelf and the wall has no steps yet, its Next leads
          // to the steps, as the foot's does (2026-10-20 rule), not to Review ("encourage users to add steps")
          var colourToSteps = !nr && shelfComplete(sh) && !S.steps.length;
          colourNext = nr ? 'Next: ' + nr.label.toLowerCase() : colourToSteps ? 'Next: choose steps' : nextAction(id).label;
          // v17: Next sits under the colours, beside the picture from 750px (under the picture it added a line of height)
          h += '<div class="cawb-colour__opts">' + opts + '<div class="cawb-colour__next"><button type="button" class="cawb-btn cawb-btn--dark" data-colour-next="' + esc(nk || '') + '"' + (colourToSteps ? ' data-add-steps data-next="steps" data-nextrow=""' : '') + '>' + esc(colourNext) + '</button></div></div></div>';
        } else h += opts;
        h += '</div></li>';
      });
      rf.fixed.forEach(function (f) {
        h += '<li class="cawb-row cawb-row--done cawb-row--fixed cawb-row--chip"><span class="cawb-row__mark" aria-hidden="true">' + TICK + '</span><span class="cawb-row__label">' + esc(f.label) + '</span><span class="cawb-row__value">' + esc(f.value) + '</span></li>';
      });
      h += '</ul>';
      var left = todoList().filter(function (t) { return t.tab === id; }).length;
      if (sh.handle && left) h += '<p class="cawb-panel__left">' + left + (left === 1 ? ' choice' : ' choices') + ' left on this shelf.</p>';
      // #104 2026-10-20 (Martin): every tab ends in the same pair, a filled main button and an outlined one the same size.
      // A finished shelf with no steps leads to the steps ("start from the floor"). The second button adds a shelf while
      // there is room, else goes to whichever of steps / review the main one does not. Remove is the x on the shelf.
      var toSteps = shelfComplete(sh) && !S.steps.length, mainTo = toSteps ? 'steps' : nextAction(id).id;
      // the open colour row already carries this same Next: not a second copy of it in the foot (final review)
      // v17 (the 2026-10-20 review's F3, not built until now): while the shelf has choices left, the main button finishes
      // the shelf: it names and opens the next unanswered question (never the open one), not the next tab
      var fk = sh.handle ? nextOpen(id, rf.rows, doneMap, open) : null;
      if (fk === open) fk = null;
      var fr = fk ? rf.rows.filter(function (x) { return x.key === fk; })[0] : null;
      var mainLabel = toSteps ? 'Next: choose steps' : fr ? 'Next: ' + fr.label.toLowerCase() : nextAction(id).label;
      // v18 (re-review): with the colour row's own Next standing in for the main button, the one left (+ Add another
      // shelf) is drawn as a quiet link (--solo), so it does not read as the next step
      h += '<div class="cawb-panel__foot' + (colourNext === mainLabel ? ' cawb-panel__foot--solo' : '') + '">' + (colourNext === mainLabel ? '' : toSteps ? '<button type="button" class="cawb-btn cawb-btn--dark" data-add-steps data-next="steps" data-nextrow="">Next: choose steps</button>' :
        fr ? '<button type="button" class="cawb-btn cawb-btn--dark" data-open-row="' + esc(fk) + '">' + esc(mainLabel) + '</button>' : nextBtn(id));
      h += S.shelves.length < MAX_SHELVES ? outlineBtn('data-add-shelf', '+ Add another shelf') :
        mainTo === 'review' ? outlineBtn('data-next="steps" data-nextrow=""', 'Edit steps') : outlineBtn('data-next="review" data-nextrow=""', 'Review my wall');
      return h + '</div>';
    }
    // #104 review 2026-10-20: the shelves are a one-row carousel; desktop gets previous/next buttons, a phone swipes
    function carouselArrows(i) {
      var arrow = function (d) { return '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="' + (d < 0 ? 'M10 3L5 8l5 5' : 'M6 3l5 5-5 5') + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
      return '<div class="cawb-car__bar"><span class="cawb-car__hint">' + SHELVES.length + ' shelves' + (window.innerWidth < 1000 ? '. Swipe to see them all.' : '') + '</span>' +
        '<span class="cawb-car__btns"><button type="button" class="cawb-car__btn" data-car-prev aria-controls="cawb-cards-' + i + '" aria-label="Previous shelves" disabled>' + arrow(-1) + '</button>' +
        '<button type="button" class="cawb-car__btn" data-car-next aria-controls="cawb-cards-' + i + '" aria-label="More shelves">' + arrow(1) + '</button></span></div>';
    }
    function carState(t) {
      var f = t.closest('fieldset'), p = f && f.querySelector('[data-car-prev]'), n = f && f.querySelector('[data-car-next]');
      if (p) p.disabled = t.scrollLeft <= 2;
      if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    }
    function carMove(b, dir) {
      var t = document.getElementById(b.getAttribute('aria-controls')), c = t && t.querySelector('.cawb-card');
      if (!c) return;
      var step = c.getBoundingClientRect().width + 10, by = Math.max(1, Math.floor((t.clientWidth + 10) / step)) * step;
      t.scrollBy({ left: dir * by, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    // after every render: a carousel opens AT the chosen shelf (not back at the first card)
    function centreChosen() {
      Array.prototype.forEach.call(el.panels.querySelectorAll('[data-car]'), function (t) {
        var on = t.querySelector('input:checked'), c = on && on.closest('.cawb-card');
        if (c) t.scrollLeft += c.getBoundingClientRect().left - t.getBoundingClientRect().left - 2;
        carState(t);
      });
    }
    function shelfCards(i, sh) {
      var h = '<fieldset class="cawb-opts"><legend>Shelf ' + (i + 1) + ': choose a shelf</legend>';
      h += carouselArrows(i);
      h += '<div class="cawb-cards" id="cawb-cards-' + i + '" data-car>';
      SHELVES.forEach(function (p) {
        var so = optOf(p, 'Size'), sizes = so ? uniq(so.values.map(function (v) { return v.split(' - ')[0]; })) : [];
        var on = sh.handle === p.handle, idr = 'cawb-card-' + i + '-' + p.handle;
        h += '<div class="cawb-card"><input type="radio" name="cawb-shelf-' + i + '" id="' + idr + '" value="' + esc(p.handle) + '"' + (on ? ' checked' : '') + ' data-shelf="' + i + '" data-axis="shelf">' +
          '<span class="cawb-card__on">' + TICK + 'Chosen</span>' +
          (p.image ? '<img class="cawb-card__img" src="' + esc(img(p.image, 360)) + '" alt="" loading="lazy" width="360" height="270">' : '<span class="cawb-card__img"></span>') +
          '<label class="cawb-card__txt" for="' + idr + '"><span class="cawb-card__name">' + esc(p.name) + '</span>' +
          '<span class="cawb-card__meta">' + esc(sizes.length > 1 ? sizes.join(', ').replace(/, ([^,]*)$/, ' or $1') : (sizes[0] || '')) + (p.ca_type === 'cat shelf wood' ? ', wood base' : ', metal base') + '</span>' +
          '<span class="cawb-card__price">from ' + money(minPrice(p)) + '</span></label>' +
          '<button type="button" class="cawb-link" data-details="' + esc(p.handle) + '" data-for="' + i + '">Details<span class="cawb-sr"> of ' + esc(p.name) + '</span></button></div>';
      });
      return h + '</div></fieldset>';
    }
    function optGroup(name, r, cur, extra, attrs) {
      // #104 R15 (Martin's phone, 2026-10-22: "Colour options take up way too much room"): colours are circles in a grid
      // with the name under each; sizes are equal buttons side by side with the price under the size
      var kind = r.swatch ? ' cawb-opts--swatch' : r.key === 'Size' ? ' cawb-opts--size' : '';
      var h = '<fieldset class="cawb-opts' + kind + '"><legend>' + esc(r.label) + '</legend><div class="cawb-opts__grid">';
      r.values.forEach(function (v) {
        var ex = extra ? extra(v) : '';
        h += '<label class="cawb-opt"><input type="radio" name="' + esc(name) + '" value="' + esc(v) + '"' + (v === cur ? ' checked' : '') + ' data-axis="' + esc(r.key) + '" ' + attrs + '>' +
          '<span class="cawb-opt__face">' + (r.swatch ? '<span class="cawb-dot" style="background:' + (HEX[v] || NEUTRAL) + '" aria-hidden="true"></span>' : '') + '<span class="cawb-opt__name">' + esc(v) + '</span>' + (ex ? ' <small>' + ex + '</small>' : '') + '</span></label>';
      });
      return h + '</div></fieldset>';
    }

    function stepsPanel() {
      var rs = realStep();
      // v17: no head photo here: the step card right under it shows the same photo
      var h = '<div class="cawb-panel__head cawb-panel__head--noimg"><div>' +
        '<h3 class="cawb-panel__title">Steps from the floor</h3><p class="cawb-panel__meta">Choose which steps and how many. The drawing shows up to 5; any more are listed with your parts.</p></div></div>';
      h += '<div class="cawb-steplist">';
      STEP_PRODUCTS.forEach(function (sp) {
        var n = stepCount(sp.handle), canAdd = S.steps.length < MAX_STEPS;
        var fit = (sp.facts.filter(function (f) { return f.slot === 'Fit'; })[0] || {}).text;
        h += '<div class="cawb-stepcard">' + (sp.image ? '<img class="cawb-stepcard__img" src="' + esc(img(sp.image, 160)) + '" alt="" width="72" height="72">' : '<span class="cawb-stepcard__img"></span>') +
          '<div><h4 class="cawb-stepcard__name">' + esc(sp.name) + '</h4>' +
          '<p class="cawb-stepcard__txt">' + money(minPrice(sp)) + ' each' + (fit ? '. ' + esc(fit) : '') + '</p>' +
          '<p class="cawb-stepcard__finish">' + esc(finishNote(sp)) + '</p>';
        h += '<div class="cawb-stepcard__row"><div class="cawb-qty" role="group" aria-label="How many ' + esc(sp.name) + '">' +
          '<button type="button" data-qty="-1" data-h="' + esc(sp.handle) + '" aria-label="One fewer"' + (n ? '' : ' disabled') + '>&minus;</button>' +
          '<output aria-live="polite">' + n + '</output>' +
          '<button type="button" data-qty="1" data-h="' + esc(sp.handle) + '" aria-label="One more"' + (canAdd ? '' : ' disabled') + '>+</button></div>' +
          '<button type="button" class="cawb-link" data-details="' + esc(sp.handle) + '">Photos and full details</button></div></div>';
        h += stepColours(sp);
        h += '</div>';
      });
      h += '</div>';
      if (!S.steps.length) h += '<p class="cawb-panel__meta">No steps yet. Add steps for a climb that starts from the floor.</p>';
      h += '<div class="cawb-panel__foot">' + nextBtn('steps') +
        (S.shelves.length ? outlineBtn('data-next="' + shelvesTab() + '" data-nextrow=""', 'Back to shelves') : outlineBtn('data-add-shelf', '+ Add a shelf')) + '</div>';
      return h;
    }
    // #104 review 2026-10-20 (Martin): each step card says what can be chosen. A step with colour options names them
    // (from its live option names); a step with none says it comes in one finish, with the section's per-handle note.
    function finishNote(sp) {
      var rows = stepRows(sp);
      if (!rows.length) return sp.finish ? 'One finish: ' + sp.finish : 'One standard finish.';
      var labels = rows.map(function (r) { return r.label.toLowerCase(); });
      var colours = labels.every(function (l) { return / colou?r$/.test(l); });
      var words = colours ? labels.map(function (l) { return l.replace(/ colou?r$/, ''); }) : labels;
      var list = words.length > 1 ? words.slice(0, -1).join(', ') + ' and ' + words[words.length - 1] : words[0];
      return 'Comes in a choice of ' + list + (colours ? ' colours.' : '.');
    }
    // The colour questions for one step product, INSIDE its card, shown only while that step is in the wall
    function stepColours(sp) {
      var rows = stepRows(sp), n = stepCount(sp.handle);
      if (!rows.length || !n) return '';
      var h = '<div class="cawb-stepcard__colours"><p class="cawb-stepcard__colours-h">Choose your ' + esc(sp.name) + ' colours</p>';
      if (!S.perStep) {
        var sh = sharedFor(sp.handle), open = firstOpen('steps', rows, sh.done);
        h += '<ul class="cawb-rows unstyled-list">';
        rows.forEach(function (r) {
          var done = !!sh.done[r.key], isOpen = open === r.key, k = rk(r.key);
          h += '<li class="cawb-row' + (done ? ' cawb-row--done' : '') + '"><h5 class="cawb-row__h"><button type="button" class="cawb-row__btn" id="cawb-rowbtn-steps-' + k + '" aria-expanded="' + isOpen + '" aria-controls="cawb-rowbody-steps-' + k + '" data-row="' + esc(r.key) + '">' +
            '<span class="cawb-row__mark" aria-hidden="true">' + (done ? TICK : '') + '</span><span class="cawb-row__label">' + esc(r.label) + '</span>' +
            '<span class="cawb-row__value' + (done ? '' : ' cawb-row__value--todo') + '">' + (done ? esc(sh.ui[r.key]) + '<span class="cawb-sr">, chosen</span>' : 'Not chosen') + CHEV + '</span></button></h5>' +
            '<div class="cawb-row__body" id="cawb-rowbody-steps-' + k + '"' + (isOpen ? '' : ' hidden') + '><p class="cawb-row__help">Used on every ' + esc(sp.name) + ' in your wall.</p>' +
            optGroup('cawb-st-' + sp.handle + '-' + k, r, done ? sh.ui[r.key] : null, null, 'data-steph="' + esc(sp.handle) + '"') + '</div></li>';
        });
        h += '</ul>';
      }
      if (n > 1 || S.perStep) {
        h += '<label class="cawb-switch"><input type="checkbox" data-perstep' + (S.perStep ? ' checked' : '') + '> Colour each step separately</label>';
      }
      if (S.perStep) {
        h += '<ul class="cawb-perstep">';
        S.steps.forEach(function (st, idx) {
          if (st.handle !== sp.handle) return;
          h += '<li><b>Step ' + (idx + 1) + '</b>';
          rows.forEach(function (r) {
            h += '<label>' + esc(r.label) + '<select data-stepi="' + idx + '" data-axis="' + esc(r.key) + '"><option value="">Choose</option>' +
              r.values.map(function (v) { return '<option' + (st.ui[r.key] === v ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') + '</select></label>';
          });
          h += '</li>';
        });
        h += '</ul>';
      }
      return h + '</div>';
    }

    // #104 v16 (Martin 2026-10-22): the PDP delivery/warranty box sits beside the "Your wall" intro on desktop; below
    // 1000px (one column) it goes straight under the Review buttons instead. One source: the Liquid-rendered box (already
    // carrying its live "Dispatched by" date) is copied here on each render; CSS shows one or the other.
    function trustBox() {
      var src = document.querySelector('[data-cawb-trustbox] .dpc-trust');
      return src ? '<div class="cawb-review__trust">' + src.outerHTML + '</div>' : '';
    }
    function reviewPanel() {
      var L = lines(), t = totals(), todo = todoList();
      var h = '<h3 class="cawb-panel__title cawb-panel__title--review">Your wall</h3>';
      if (todo.length) {
        h += '<div class="cawb-todo" id="cawb-todo" tabindex="-1"><p>' + todo.length + (todo.length === 1 ? ' choice' : ' choices') + ' left before you can add to basket</p><ul>' +
          todo.map(function (x) { return '<li><button type="button" class="cawb-link" data-goto="' + x.tab + '" data-gorow="' + esc(x.row || '') + '">' + esc(x.text) + '</button></li>'; }).join('') + '</ul></div>';
      }
      h += '<ul class="cawb-parts">';
      // shown shelf first, the main purchase (final review); the basket still adds in route order
      L.filter(function (l) { return !stepByHandle[l.p.handle]; }).concat(L.filter(function (l) { return !!stepByHandle[l.p.handle]; })).forEach(function (l) {
        var th = l.v.thumb || l.p.image;
        h += '<li class="cawb-part">' + (th ? '<img src="' + esc(img(th, 120)) + '" alt="" width="56" height="56">' : '<span class="cawb-part__ph"></span>') + '<span class="cawb-part__name">' + esc(l.p.name) + '</span>' +
          '<span class="cawb-part__sum">' + money(l.v.price * l.qty) + '<small>' + l.qty + ' &times; ' + money(l.v.price) + '</small></span>' +
          '<span class="cawb-part__opts">' + esc(l.label) + (l.props && l.props['Base Fabric'] ? ', base fabric ' + esc(l.props['Base Fabric']) : '') + '</span></li>';
      });
      h += '</ul>';
      h += '<div class="cawb-review__total"><span>' + (t.from ? 'Total so far, from' : 'Total') + '</span><b>' + money(t.cents) + '</b></div>';
      h += '<div class="cawb-panel__foot"><button type="button" class="cawb-btn cawb-btn--dark" data-addall aria-disabled="' + (todo.length || !L.length ? 'true' : 'false') + '">' + (S.added ? 'View basket' : 'Add all to basket') + '</button>' +
        outlineBtn('data-next="steps" data-nextrow=""', 'Back to steps') + '</div>';
      h += trustBox();
      h += '<ul class="cawb-review__lines"><li>Each part is its own item in your basket, with its own size and colours.</li><li>Handmade to order in Poland by Cat&#39;s Atelier.</li></ul>';
      return h;
    }

    // ---------------------------------------------------------------- drawing (engine v4 planFrozen; 1 unit = 1 cm)
    var lastPlan = null;
    function drawWall() {
      var geo = S.shelves.map(function (sh) {
        var w = 75, thick = 4;
        if (sh.handle) {
          var p = byHandle[sh.handle], ui = shelfUiFull(sh);
          var size = ui.Size || (optOf(p, 'Size') ? optOf(p, 'Size').values[0] : '75');
          var mm = String(size).match(/\d+/);
          w = mm ? parseInt(mm[0], 10) : 75; thick = p.thick;
        }
        return { w: w, thick: thick, label: '' };
      });
      var plan = R.planFrozen(S.steps.length, geo);
      lastPlan = plan;
      var items = plan ? plan.items : [];
      var compact = window.innerWidth < 1000;
      var box = el.stage.getBoundingClientRect();
      var fp = R.footprint({ items: items });
      var LEFT = compact ? 8 : 34, RIGHT = 8, TOP = compact ? 22 : 14;
      var left = items.length ? fp.left : -60, width = items.length ? fp.width : 120;
      // v17 (design review): desktop draws 40cm of wall above the top piece, not a fixed 200cm, so one
      // shelf no longer sits under half a box of empty wall (140cm at least); TOP_CAP_CM stays the placement limit
      // (CaRules), not this. FLOOR: room under the floor line for a strip of floor (desktop), with a skirting board above it
      var FLOOR = compact ? 6 : 10;
      var hCm = compact ? Math.max(90, fp.top + 6) : Math.max(140, fp.top + 40);
      var vbW = Math.max(width + LEFT + RIGHT, compact ? 120 : 140), vbH = hCm + TOP + FLOOR;
      // keep the drawing's aspect in the box by widening the view (wall reads as a wall), or growing its height
      if (box.width && box.height) { var ar = box.width / box.height; if (vbW / vbH < ar) vbW = vbH * ar; else { var extra = vbW / ar - vbH; TOP += extra; vbH += extra; } }
      var pad = (vbW - (width + LEFT + RIGHT)) / 2;
      var scale = box.width ? Math.min(box.width / vbW, box.height / vbH) : 3;
      var fs = (compact ? 12 : 13) / scale;
      function X(x) { return (x - left + LEFT + pad).toFixed(1); }
      function Y(y) { return (TOP + hCm - y).toFixed(1); }
      var byKey = {}; items.forEach(function (i) { byKey[i.key] = i; });
      var active = S.tab;
      var s = ['<svg viewBox="0 0 ' + vbW.toFixed(1) + ' ' + vbH.toFixed(1) + '" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'];
      s.push('<rect class="cawb-svg-wall" x="0" y="0" width="' + vbW.toFixed(1) + '" height="' + Y(0) + '"/>');
      if (!compact) {
        s.push('<rect class="cawb-svg-skirt" x="0" y="' + Y(8) + '" width="' + vbW.toFixed(1) + '" height="8"/>');
        s.push('<rect class="cawb-svg-floorband" x="0" y="' + Y(0) + '" width="' + vbW.toFixed(1) + '" height="' + (vbH - Number(Y(0))).toFixed(1) + '"/>');
      }
      s.push('<line class="cawb-svg-floor" x1="0" x2="' + vbW.toFixed(1) + '" y1="' + Y(0) + '" y2="' + Y(0) + '"/>');
      if (!compact) {
        var hts = uniq(items.map(function (i) { return i.y; })).sort(function (a, b) { return a - b; });
        hts.forEach(function (hh) {
          s.push('<line class="cawb-svg-tick" x1="' + (LEFT - 4) + '" x2="' + vbW.toFixed(1) + '" y1="' + Y(hh) + '" y2="' + Y(hh) + '"/>');
          s.push('<text class="cawb-svg-t cawb-svg-t--muted" x="' + (LEFT - 6) + '" y="' + (Number(Y(hh)) + fs * 0.35).toFixed(1) + '" font-size="' + fs.toFixed(2) + '" text-anchor="end">' + hh + '</text>');
        });
        // the heights' unit, once, above the top one (final review)
        if (hts.length) s.push('<text class="cawb-svg-t cawb-svg-t--muted" x="' + (LEFT - 6) + '" y="' + (Number(Y(hts[hts.length - 1])) - fs * 1.1).toFixed(1) + '" font-size="' + fs.toFixed(2) + '" text-anchor="end">cm</text>');
      }
      items.forEach(function (b) {
        (b.from || []).forEach(function (fk) {
          var x1, y1, x2, y2;
          if (fk === 'floor') { x1 = x2 = b.x + b.w / 2; y1 = 0; y2 = b.y; }
          else {
            var a = byKey[fk]; if (!a) return;
            x1 = a.kind === 'step' ? a.x + a.w / 2 : (b.x + b.w / 2 < a.x + a.w / 2 ? a.x + 4 : a.x + a.w - 4);
            x2 = b.kind === 'step' ? b.x + b.w / 2 : (x1 < b.x ? b.x + 4 : (x1 > b.x + b.w ? b.x + b.w - 4 : x1));
            y1 = a.y; y2 = b.y;
          }
          s.push('<line class="cawb-svg-route" x1="' + X(x1) + '" y1="' + Y(y1) + '" x2="' + X(x2) + '" y2="' + Y(y2) + '"/>');
        });
      });
      items.forEach(function (it) {
        var n = Number(it.key.split('_')[1]), g = '';
        if (it.kind === 'step') {
          var st = S.steps[n - 1] || { handle: realStep().handle, ui: {} }, sp = stepByHandle[st.handle];
          var on = active === 'steps';
          var ui = stepUi(st), only = stepRows(sp).length ? null : (HEX[sp.options[sp.options.length - 1].values[0]] || NEUTRAL);
          if (only) {
            g += '<rect class="cawb-svg-piece" x="' + X(it.x) + '" y="' + Y(it.y) + '" width="' + it.w + '" height="4" rx="2" style="fill:' + only + '"/>';
          } else {
            g += '<rect class="cawb-svg-piece" x="' + X(it.x) + '" y="' + Y(it.y) + '" width="' + it.w + '" height="2" style="fill:' + (HEX[ui['Felt Colour']] || NEUTRAL) + '"/>';
            g += '<rect class="cawb-svg-piece" x="' + X(it.x) + '" y="' + (Number(Y(it.y)) + 2).toFixed(1) + '" width="' + it.w + '" height="2" style="fill:' + (HEX[ui['Platform Colour']] || NEUTRAL) + '"/>';
          }
          if (on) g += '<rect class="cawb-svg-hl" x="' + (Number(X(it.x)) - 2).toFixed(1) + '" y="' + (Number(Y(it.y)) - 2).toFixed(1) + '" width="' + (it.w + 4) + '" height="8" rx="1.5"/>';
          if (!compact) g += '<text class="cawb-svg-t ' + (on ? 'cawb-svg-t--on' : 'cawb-svg-t--muted') + '" x="' + X(it.x + it.w / 2) + '" y="' + (Number(Y(it.y)) - 3.5).toFixed(1) + '" font-size="' + fs.toFixed(2) + '" text-anchor="middle">' + n + '</text>';
        } else {
          var sh = S.shelves[n - 1] || blankShelf(), on2 = active === 'shelf-' + (n - 1), th = it.thick || 4;
          if (!sh.handle) {
            g += '<rect class="cawb-svg-ghost" x="' + X(it.x) + '" y="' + Y(it.y) + '" width="' + it.w + '" height="' + th + '"/>';
          } else {
            var cushion = (sh.done.Color ? HEX[sh.ui.Color] : (sh.done.Colour ? HEX[sh.ui.Colour] : NEUTRAL));
            var base = byHandle[sh.handle].ca_type === 'cat shelf' ? (sh.done['Base Fabric'] ? HEX[sh.ui['Base Fabric']] : '#bdb7aa') : (sh.done['Wood Finish'] ? HEX[sh.ui['Wood Finish']] : '#bdb7aa');
            g += '<rect class="cawb-svg-piece" x="' + X(it.x) + '" y="' + Y(it.y) + '" width="' + it.w + '" height="' + (th / 2) + '" style="fill:' + (cushion || NEUTRAL) + '"/>';
            g += '<rect class="cawb-svg-piece" x="' + X(it.x) + '" y="' + (Number(Y(it.y)) + th / 2).toFixed(1) + '" width="' + it.w + '" height="' + (th / 2) + '" style="fill:' + (base || '#bdb7aa') + '"/>';
          }
          if (on2) g += '<rect class="cawb-svg-hl" x="' + (Number(X(it.x)) - 2).toFixed(1) + '" y="' + (Number(Y(it.y)) - 2).toFixed(1) + '" width="' + (it.w + 4) + '" height="' + (th + 4) + '" rx="1.5"/>';
          var lab = compact ? (sh.handle ? 'Shelf ' + n : 'Shelf ' + n + '?') : 'Shelf ' + n + (sh.handle ? '' : ': choose');
          g += '<text class="cawb-svg-t ' + (on2 ? 'cawb-svg-t--on' : 'cawb-svg-t--b') + '" x="' + X(it.x + it.w / 2) + '" y="' + (Number(Y(it.y)) - 3.5).toFixed(1) + '" font-size="' + fs.toFixed(2) + '" text-anchor="middle">' + lab + '</text>';
        }
        s.push('<g data-piece="' + it.key + '">' + g + '</g>');
      });
      s.push('</svg>');
      el.svg.innerHTML = s.join('');
      var ov = R.overflowOf(S.steps.length, S.shelves.length, R.CONSTANTS).label;
      el.overflow.hidden = !ov;
      el.overflow.textContent = ov ? ov + ' not drawn' : '';
      el.empty.hidden = !!items.length;
      el.stage.setAttribute('aria-label', !items.length ? 'Your wall: empty' : 'Your wall: ' + items.map(function (i) {
        var n = i.key.split('_')[1];
        if (i.kind === 'step') return 'step ' + n + ' at ' + i.y + ' cm';
        var sh = S.shelves[n - 1];
        return 'shelf ' + n + (sh && sh.handle ? ' (' + byHandle[sh.handle].name + ')' : ' (not chosen)') + ' at ' + i.y + ' cm';
      }).join(', ') + (ov ? '; ' + ov + ' not drawn' : ''));
    }

    function renderBar() {
      var t = totals();
      // #104 final review: a phone shows the short forms ("From", "3 choices left"), so the bar stays one line
      el.totalLabel.innerHTML = t.from ? '<span class="cawb-bar-long">Total so far, from</span><span class="cawb-bar-short">From</span>' : 'Total';
      el.total.textContent = money(t.cents);
      el.total.setAttribute('data-cents', String(t.cents));
      var pieces = S.shelves.length + (S.shelves.length === 1 ? ' shelf, ' : ' shelves, ') + S.steps.length + (S.steps.length === 1 ? ' step' : ' steps');
      // the basket bar shows once anything is chosen and pads the page so it never covers the end (decision 2026-10-17)
      el.buybar.hidden = isEmpty();
      var left = isEmpty() ? 0 : todoList().length;
      if (isEmpty()) el.count.textContent = 'Nothing added yet';
      else if (left) el.count.innerHTML = '<span class="cawb-bar-long">' + pieces + ', </span>' + left + (left === 1 ? ' choice' : ' choices') + ' left';
      else el.count.textContent = pieces;
      if (el.barAdd && !adding) { el.barAdd.textContent = S.added ? 'View basket' : 'Add all to basket'; el.barAdd.setAttribute('aria-describedby', 'cawb-bar-count'); }
      document.body.classList.toggle('cawb-has-bar', !el.buybar.hidden);
      document.documentElement.style.setProperty('--cawb-bar-h', el.buybar.hidden ? '0px' : el.buybar.offsetHeight + 'px');
      var idea = IDEAS.filter(function (x) { return x.id === S.idea; })[0];
      el.source.textContent = idea ? 'Started from ' + idea.name + (S.dirty ? ', then changed.' : ', with every choice filled in. Change anything you like.') :
        (isEmpty() ? 'A blank wall. Add your first shelf or some steps.' : 'Started from a blank wall.');
    }
    function scrollToPlanner() {
      if (!el.planner) return;
      // +4: the section's gold mark tucks under the menu instead of showing as a second marker (final review)
      var t = el.planner.getBoundingClientRect().top + window.scrollY + 4 - headerH() - 49; // 49 = the in-page nav, fixed by then
      window.scrollTo({ top: t, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function renderIdeas() {
      IDEAS.forEach(function (x) {
        x.el.setAttribute('aria-pressed', String(S.idea === x.id));
        var pr = x.el.querySelector('[data-cawb-idea-price]');
        if (pr && pr.getAttribute('data-cents') !== String(x.cents)) { pr.setAttribute('data-cents', String(x.cents)); pr.textContent = ', from ' + money(x.cents); }
      });
      if (el.blank) el.blank.setAttribute('aria-pressed', String(S.idea === 'blank'));
    }
    // #104 2026-10-20 (Martin): the wall survives a refresh or a visit elsewhere and back. Kept in this browser only
    // (localStorage, 30 days); a deep link (?idea= / ?shelf=) still wins, and anything no longer on sale, or an answer a
    // product no longer offers, is dropped quietly on the way back. Storage can be blocked: the page works without it.
    var SAVE_KEY = 'cawb-wall-v1', canSave = false;
    function saveWall() {
      if (!canSave) return;
      try {
        localStorage.setItem(SAVE_KEY, JSON.stringify({ t: Date.now(), shelves: S.shelves, steps: S.steps, stepShared: S.stepShared,
          perStep: S.perStep, tab: S.tab, idea: S.idea, dirty: S.dirty }));
      } catch (e) { /* private mode or blocked storage */ }
    }
    function keepValid(src, rows) {
      var out = { ui: {}, done: {} };
      rows.forEach(function (r) {
        var v = src && src.ui ? src.ui[r.key] : null;
        if (v != null && r.values.indexOf(v) > -1) { out.ui[r.key] = v; if (src.done && src.done[r.key]) out.done[r.key] = true; }
      });
      return out;
    }
    function loadWall() {
      var d;
      try { d = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null'); } catch (e) { return false; }
      if (!d || !d.t || Date.now() - d.t > 30 * 864e5 || !Array.isArray(d.shelves) || !Array.isArray(d.steps)) return false;
      var shelves = d.shelves.slice(0, MAX_SHELVES).map(function (x) {
        if (!x || !x.handle) return blankShelf();
        if (!eng[x.handle] || eng[x.handle].role !== 'shelf' || !byHandle[x.handle]) return null;
        var sh = { handle: x.handle, ui: Object.assign({}, x.ui), done: {} };
        var k = keepValid(x, rowsFor(sh).rows.filter(function (r) { return r.key !== 'shelf'; }));
        sh.ui = k.ui; sh.done = k.done;
        return sh;
      }).filter(Boolean);
      var shared = {};
      STEP_PRODUCTS.forEach(function (sp) { if (d.stepShared && d.stepShared[sp.handle]) shared[sp.handle] = keepValid(d.stepShared[sp.handle], stepRows(sp)); });
      var steps = d.steps.filter(function (st) { return st && stepByHandle[st.handle]; }).slice(0, MAX_STEPS).map(function (st) {
        return { handle: st.handle, ui: keepValid({ ui: st.ui, done: st.ui }, stepRows(stepByHandle[st.handle])).ui };
      });
      if (!shelves.length && !steps.length) return false;
      S.shelves = shelves; S.steps = steps; S.stepShared = shared; S.perStep = !!d.perStep; S.open = {};
      S.idea = IDEAS.some(function (x) { return x.id === d.idea; }) ? d.idea : null; S.dirty = !!d.dirty;
      S.tab = tabIds().indexOf(d.tab) > -1 ? d.tab : (shelves.length ? 'shelf-0' : 'steps');
      render();
      return true;
    }
    // ---------------------------------------------------------------- tracking: milestones (helpers at the top)
    // Off until the landing is settled, so a deep link or a restored wall is not counted as the shopper's own progress.
    var tracking = false, fired = {}, lastTab = null, stepsSent = 0;
    var STAGES = ['view', 'start', 'shelf_done', 'review', 'add_blocked', 'added'], stageAt = -1;
    function stage(s) { var i = STAGES.indexOf(s); if (i > stageAt) { stageAt = i; clarity('cawb_stage', s); } }
    function once(key, name, params) { if (fired[key]) return false; fired[key] = true; track(name, params); return true; }
    function startOnce(type, ideaId) {
      if (!tracking || fired.start) return;
      once('start', 'cawb_start', { start_type: type, idea_id: ideaId || '' });
      stage('start');
    }
    function shelfComplete(sh) { return !!sh.handle && rowsFor(sh).rows.every(function (r) { return r.key === 'shelf' || sh.done[r.key]; }); }
    // keyed by the shelf itself, not its position: removing Shelf 1 must not count the shelf that moves up a second time
    var uidN = 0;
    function doneKey(sh) { if (!sh.uid) sh.uid = 'u' + Date.now().toString(36) + (++uidN); return 'done:' + sh.uid + ':' + sh.handle; }
    // the first open choice in the shared vocabulary: shelf_2_base_fabric, shelf_2_product, steps_felt, none
    function firstOpenSlug() {
      var t = todoList()[0];
      if (!t || t.tab === 'none') return 'none';
      if (t.tab === 'steps') {
        for (var s = 0; s < S.steps.length; s++) {
          var st = S.steps[s], ui = stepUi(st), miss = stepRows(stepByHandle[st.handle]).filter(function (r) { return !ui[r.key]; })[0];
          if (miss) return 'steps_' + rowSlug(miss.key);
        }
        return 'steps';
      }
      var n = Number(t.tab.split('-')[1]) + 1;
      return 'shelf_' + n + '_' + (t.row === 'shelf' ? 'product' : rowSlug(t.row));
    }
    function stepMix() {
      return STEP_PRODUCTS.map(function (sp) { return sp.handle + ':' + stepCount(sp.handle); }).filter(function (x) { return !/:0$/.test(x); }).join(',');
    }
    function watch() {
      S.shelves.forEach(function (sh, i) {
        if (shelfComplete(sh) && once(doneKey(sh), 'cawb_shelf_done', { shelf_index: i, product_handle: sh.handle, via: 'choice' })) stage('shelf_done');
      });
      if (lastTab === 'steps' && S.tab !== 'steps' && S.steps.length !== stepsSent) {
        stepsSent = S.steps.length;
        track('cawb_steps_set', { steps: S.steps.length, step_mix: stepMix() });
      }
      if (S.tab === 'review') {
        once('review', 'cawb_review', { shelves: S.shelves.length, steps: S.steps.length, choices_left: isEmpty() ? 0 : todoList().length,
          value: Math.round(totals().cents) / 100, currency: 'GBP' });
        stage('review');
      }
      lastTab = S.tab;
    }
    function render() {
      renderIdeas(); renderTabs(); renderPanels(); renderBar(); drawWall();
      if (el.reset) el.reset.hidden = isEmpty();
      saveWall();
      if (tracking) watch();
      centreChosen();
      rootEl.style.setProperty('--cawb-strip-h', stripH() + 'px');
      if (focusAfter) { var f = document.getElementById(focusAfter); focusAfter = null; if (f) f.focus({ preventScroll: true }); }
    }

    // ---------------------------------------------------------------- choices
    function nextOpen(id, rows, doneMap, fromKey) {
      var keys = rows.map(function (r) { return r.key; }), i = keys.indexOf(fromKey);
      for (var k = 1; k <= keys.length; k++) { var key = keys[(i + k) % keys.length]; if (!doneMap[key]) return key; }
      return null;
    }
    function chooseShelf(i, handle, advance) {
      var old = S.shelves[i], sh = { handle: handle, ui: {}, done: {} }, kept = [];
      if (old.handle === handle) return;
      startOnce('shelf');
      if (tracking) track('cawb_shelf_chosen', { shelf_index: i, product_handle: handle, via: 'choice' });
      if (old.handle) {
        // keep what still fits the new shelf (colour, base fabric, wood finish, dip, size)
        rowsFor(sh).rows.forEach(function (r) {
          if (r.key !== 'shelf' && old.done[r.key] && r.values.indexOf(old.ui[r.key]) > -1) { sh.ui[r.key] = old.ui[r.key]; sh.done[r.key] = true; kept.push(r.label.toLowerCase()); }
        });
      }
      markDirty();
      S.shelves[i] = sh;
      var id = 'shelf-' + i, rf = rowsFor(sh);
      S.open[id] = advance ? nextOpen(id, rf.rows, Object.assign({ shelf: true }, sh.done), 'shelf') : 'shelf';
      focusAfter = advance && S.open[id] ? 'cawb-rowbtn-' + id + '-' + rk(S.open[id]) : null;
      render();
      if (advance && S.open[id]) scrollRow(id, S.open[id]);
      announce('Shelf ' + (i + 1) + ': ' + byHandle[handle].name + '.' + (kept.length ? ' Kept your ' + kept.join(', ') + '.' : ''));
    }
    function chooseShelfAxis(i, key, val, advance) {
      var sh = S.shelves[i];
      sh.ui[key] = val; sh.done[key] = true;
      markDirty();
      // #104 review 6 (Martin 2026-10-21): the colour row stays open after a tap so colours can be compared in the big
      // picture; its own Next button moves on. Every other row still moves on by itself.
      if (isPicKey(key)) advance = false;
      var id = 'shelf-' + i, rf = rowsFor(sh);
      if (advance) {
        S.open[id] = nextOpen(id, rf.rows, Object.assign({ shelf: true }, sh.done), key);
        focusAfter = S.open[id] ? 'cawb-rowbtn-' + id + '-' + rk(S.open[id]) : null;
      }
      var keepFocus = !advance ? radioId() : null;
      render();
      if (keepFocus) refocusRadio(keepFocus);
      if (advance && S.open[id]) scrollRow(id, S.open[id]);
      if (advance && !S.open[id]) { var nb = el.panels.querySelector('[data-next]'); if (nb) { nb.focus({ preventScroll: true }); nb.scrollIntoView({ block: 'nearest' }); } announce('Shelf ' + (i + 1) + ' is done.'); }
    }
    function radioId() { var a = document.activeElement; return a && a.matches && a.matches('input[type=radio]') ? { name: a.name, value: a.value } : null; }
    function refocusRadio(k) {
      var r = Array.prototype.filter.call(rootEl.querySelectorAll('input[type=radio]'), function (x) { return x.name === k.name && x.value === k.value; })[0];
      if (r) r.focus({ preventScroll: true });
    }
    // #104 review 2026-10-20 (Martin): after a tapped answer the NEXT question goes to the top, directly under what is
    // fixed there, even when it is already in view lower down. The in-page nav is counted at full height before it is
    // stuck (it sticks as we scroll, and covered the row otherwise). The theme header hides on a scroll down and comes
    // back on ANY scroll up (Test 2026-10-20: a 23px correction upwards brought back its 60px and the nav covered the
    // row), so a move up aims below the header's full height and a move down assumes it goes away. Up to two instant
    // corrections, measured from where things actually are, once the smooth scroll has settled.
    var scrollFixT;
    function baseWant() {
      var nav = document.querySelector('[data-cawb-nav]');
      return (nav ? nav.offsetHeight : 0) + stripH() + (window.innerWidth < 1000 ? 70 : 0) + 8;
    }
    function headerFull() {
      var hd = document.querySelector('.shopify-section--header, header');
      return Math.max(headerH(), hd ? hd.offsetHeight : 0);
    }
    // the header's slide in/out is animated, so a mid-slide reading is partial: count it as all there or not at all
    function headerNow() { return headerH() > 0 ? headerFull() : 0; }
    function moveTo(top, smooth) {
      var up = top < headerNow() + baseWant();
      window.scrollTo({ top: window.scrollY + top - ((up ? headerFull() : 0) + baseWant()), behavior: smooth ? 'smooth' : 'auto' });
    }
    // What goes to the top. Phone: the next question. Desktop (Martin 2026-10-20, change of plan): the whole configurator
    // fits on screen, so the page goes back to the top of the planner (drawing + tabs) with the next question open; only
    // when that question would then end under the basket bar does it move further, just enough to show it.
    function anchorTop(rid) {
      var bb = document.getElementById(rid);
      if (!bb) return null;
      if (window.innerWidth < 1000) {
        // v18 (re-review): with answer chips just above the row, the row lands 8px higher, so they tuck fully under the
        // sticky tabs instead of leaving a sliver showing (reported 8px low = scrolled 8 more). Not 14: that left the row
        // 3px under the tabs, a 2px rounding read as "covered", the fix-up scrolled UP, and the theme header slid back in
        // (v5 V9 2/3 on Test). 8 keeps the row ~9px clear and the chips' bottom ~4px under the tabs.
        var li = bb.closest('.cawb-row'), pv = li && li.previousElementSibling;
        return bb.getBoundingClientRect().top + (pv && pv.classList.contains('cawb-row--chip') ? 8 : 0);
      }
      var g = (el.planner && el.planner.querySelector('.cawb-planner__grid')) || el.planner;
      if (!g) return bb.getBoundingClientRect().top;
      var gt = g.getBoundingClientRect().top, row = bb.closest('.cawb-row') || bb;
      var want = headerFull() + baseWant(), bar = el.buybar.hidden ? 0 : el.buybar.offsetHeight;
      var over = row.getBoundingClientRect().bottom - gt + want - (window.innerHeight - bar - 8);
      return gt + Math.max(0, over);
    }
    function scrollRow(id, key) {
      var rid = 'cawb-rowbtn-' + id + '-' + rk(key), b = document.getElementById(rid);
      if (!b) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = anchorTop(rid), want = headerNow() + baseWant();
      if (Math.abs(top - want) > 24) moveTo(top, !reduce);
      clearTimeout(scrollFixT);
      var fix = function (n) {
        scrollFixT = setTimeout(function () {
          var t = anchorTop(rid);
          if (t === null) return;
          var d = t - (headerNow() + baseWant());
          // a little low is fine; covered, even by a few px, is not. Keep looking after a good reading too: a late
          // layout shift (Test 2026-10-20: 11px after the jump) can still push the question under the bar.
          if (d < -1 || d > 12) moveTo(t, false);
          if (n < 3) fix(n + 1);
        }, n === 1 ? (reduce ? 50 : 700) : 350);
      };
      fix(1);
    }
    function chooseStepAxis(h, key, val, advance) {
      var sh = sharedFor(h);
      sh.ui[key] = val; sh.done[key] = true;
      markDirty();
      S.steps.forEach(function (st) { if (st.handle === h) st.ui[key] = val; });
      if (advance) {
        S.open.steps = nextOpen('steps', stepRows(stepByHandle[h]), sh.done, key);
        focusAfter = S.open.steps ? 'cawb-rowbtn-steps-' + rk(S.open.steps) : null;
      }
      var keep = !advance ? radioId() : null;
      render();
      if (keep) refocusRadio(keep);
      if (advance && S.open.steps) scrollRow('steps', S.open.steps);
      if (advance && !S.open.steps) { var nb = el.panels.querySelector('[data-next]'); if (nb) nb.focus({ preventScroll: true }); }
    }
    function copyFromFirst(i) {
      var src = S.shelves[0], dst = S.shelves[i], copied = [], skipped = [];
      markDirty();
      if (!dst.handle) {
        S.shelves[i] = JSON.parse(JSON.stringify(src));
        delete S.shelves[i].uid; // a copy is a new shelf (its own cawb_shelf_done)
        S.open['shelf-' + i] = null;
        S.copyMsg = { i: i, text: 'Copied Shelf 1: ' + byHandle[src.handle].name + (shortSpec(src).length ? ', ' + shortSpec(src).join(', ') : '') + '.' };
        render(); announce(S.copyMsg.text);
        return;
      }
      var srcRows = rowsFor(src).rows;
      rowsFor(dst).rows.forEach(function (r) {
        if (r.key === 'shelf') return;
        if (src.done[r.key] && r.values.indexOf(src.ui[r.key]) > -1) { dst.ui[r.key] = src.ui[r.key]; dst.done[r.key] = true; copied.push(r.label.toLowerCase() + ' ' + src.ui[r.key]); }
        else if (srcRows.some(function (x) { return x.key === r.key; }) && src.done[r.key]) skipped.push(r.label.toLowerCase() + ' (' + src.ui[r.key] + ' is not offered on ' + byHandle[dst.handle].name + ')');
        else skipped.push(r.label.toLowerCase() + ' (Shelf 1 has no ' + r.label.toLowerCase() + ')');
      });
      delete S.open['shelf-' + i];
      S.copyMsg = { i: i, text: (copied.length ? 'Copied ' + copied.join(', ') + '.' : 'Nothing to copy.') + (skipped.length ? ' Still to choose: ' + skipped.join('; ') + '.' : '') };
      render(); announce(S.copyMsg.text);
    }

    // ---------------------------------------------------------------- details panel (in page, never a new page: Martin Q9)
    // #104 redesign point 6: the photo of what the shopper has CHOSEN (grey chosen = the grey photo): the shelf's resolved
    // variant (or the closest match so far) for a shelf on the wall, the first step's variant for a step product.
    function chosenThumb(p, forShelf) {
      var sh = forShelf != null ? S.shelves[forShelf] : null;
      if (sh && sh.handle === p.handle) return shelfThumb(sh);
      var st = stepByHandle[p.handle] ? S.steps.filter(function (x) { return x.handle === p.handle; })[0] : null;
      var v = st ? stepVariant(st) : null;
      return v && v.thumb ? v.thumb : null;
    }
    function baseUrl(u) { return String(u || '').split('?')[0]; }
    function galImages(p, forShelf) {
      var imgs = (p.images.length ? p.images : [{ src: p.image, alt: p.name }]).filter(function (x) { return x && x.src; });
      var th = chosenThumb(p, forShelf);
      if (th && !imgs.some(function (x) { return baseUrl(x.src) === baseUrl(th); })) imgs = [{ src: th, alt: p.name + ', as chosen' }].concat(imgs);
      return imgs;
    }
    function galStart(p, forShelf) {
      var th = chosenThumb(p, forShelf), imgs = galImages(p, forShelf), k = -1;
      imgs.forEach(function (x, i) { if (k < 0 && th && baseUrl(x.src) === baseUrl(th)) k = i; });
      return Math.max(0, k);
    }
    function galGo(k, smooth) {
      var track = el.drawer.querySelector('[data-gal-track]');
      if (!track) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: k * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      galMark(k);
    }
    function galMark(k) {
      el.drawer.querySelectorAll('[data-gal-slide]').forEach(function (x, i) { if (i === k) x.setAttribute('data-gal-active', ''); else x.removeAttribute('data-gal-active'); });
      el.drawer.querySelectorAll('[data-gal-dot]').forEach(function (x, i) { x.setAttribute('aria-current', String(i === k)); });
      el.drawer.querySelectorAll('[data-gal]').forEach(function (x, i) { x.setAttribute('aria-current', String(i === k)); });
      var c = el.drawer.querySelector('[data-gal-count]'); if (c) c.textContent = 'Photo ' + (k + 1) + ' of ' + el.drawer._imgs.length;
    }
    function openDrawer(handle, forShelf) {
      var p = byHandle[handle];
      var sh = forShelf != null ? S.shelves[forShelf] : null;
      var size = sh && sh.handle === handle && (sh.done.Size || rowsFor(sh).fixed.some(function (f) { return f.key === 'Size'; })) ? shelfUiFull(sh).Size : null;
      var imgs = galImages(p, forShelf);
      var start = galStart(p, forShelf);
      var price = minPrice(p) === Math.max.apply(null, p.variants.map(function (v) { return v.price; })) ? money(minPrice(p)) : 'from ' + money(minPrice(p));
      var h = '<div class="cawb-drawer__top"><h2 id="cawb-drawer-h">' + esc(p.name) + '</h2><button type="button" class="cawb-drawer__close" data-close aria-label="Close details">&times;</button></div>';
      if (imgs.length) {
        // a swipe track (point 6b): one photo per slide with scroll snap; dots on a phone, thumbnails on desktop
        h += '<div class="cawb-gal"><div class="cawb-gal__track" data-gal-track tabindex="0" role="group" aria-roledescription="carousel" aria-label="Photos of ' + esc(p.name) + '. Swipe or use the arrow keys.">';
        imgs.forEach(function (im, k) {
          h += '<figure class="cawb-gal__slide" data-gal-slide' + (k === start ? ' data-gal-active' : '') + ' aria-label="Photo ' + (k + 1) + ' of ' + imgs.length + '"><img src="' + esc(img(im.src, 900)) + '" alt="' + esc(im.alt || p.name) + '"' + (Math.abs(k - start) > 1 ? ' loading="lazy"' : '') + ' width="900" height="675"></figure>';
        });
        h += '</div>';
        if (imgs.length > 1) {
          h += '<div class="cawb-gal__dots" data-gal-dots aria-hidden="true">' + imgs.map(function (_, k) { return '<span data-gal-dot aria-current="' + (k === start) + '"></span>'; }).join('') + '</div>';
          h += '<p class="cawb-sr" aria-live="polite" data-gal-count></p>';
          h += '<div class="cawb-gal__thumbs" role="group" aria-label="Photos">';
          imgs.forEach(function (im, k) {
            h += '<button type="button" data-gal="' + k + '" aria-current="' + (k === start) + '" aria-label="Photo ' + (k + 1) + ' of ' + imgs.length + '"><img src="' + esc(img(im.src, 120)) + '" alt="" loading="lazy" width="56" height="56"></button>';
          });
          h += '</div>';
        }
        h += '</div>';
      }
      h += '<p class="cawb-panel__price">' + price + '</p>';
      // point 6c: the pop-up keeps the build; the full product page is one tap away in a new tab
      h += '<a class="cawb-link cawb-drawer__pdp" href="' + esc(p.url || ('/products/' + p.handle)) + '" target="_blank" rel="noopener" data-cawb-pdp>Open full product page<span class="cawb-sr"> (opens in a new tab)</span></a>';
      var ticks = p.facts.filter(function (f) { return f.slot === 'Fit' || f.slot === 'Material' || f.slot === 'Difference'; });
      if (ticks.length) {
        h += '<h3 class="cawb-drawer__h3">Key features</h3><ul class="cawb-facts">' + ticks.map(function (f) { return '<li data-cawb-tick>' + TICK + '<span>' + esc(f.text) + '</span></li>'; }).join('') + '</ul>';
      }
      var dims = dimsFor(p, size), load = loadFor(p, size);
      var dimsHit = dims && size && dims.indexOf(String(size).match(/\d+/)[0] + ' x') === 0;
      if (load && !size && /\(/.test(p.maxLoad)) load = p.maxLoad; // size not chosen yet: the whole rating, never a guess
      if (dimsHit || load) {
        h += '<dl class="cawb-kv">' + (dimsHit ? '<div><dt>Size (' + esc(size) + ')</dt><dd>' + esc(dims) + '</dd></div>' : '') +
          (load ? '<div><dt>Holds up to</dt><dd>' + esc(load) + '</dd></div>' : '') + '</dl>';
      }
      if (p.specs.length) {
        h += '<h3 class="cawb-drawer__h3">Specs</h3><dl class="cawb-specs">' + p.specs.map(function (s) { return '<div><dt>' + esc(s.label) + '</dt><dd>' + esc(s.value) + '</dd></div>'; }).join('') + '</dl>';
      }
      if (forShelf != null && (!sh || sh.handle !== handle) && SHELVES.indexOf(p) > -1) {
        h += '<button type="button" class="cawb-btn cawb-btn--dark cawb-btn--block" data-pick="' + esc(handle) + '" data-for="' + forShelf + '">Use this for Shelf ' + (forShelf + 1) + '</button>';
      } else {
        h += '<button type="button" class="cawb-btn cawb-btn--block" data-close>Back to your wall</button>';
      }
      el.drawerBody.innerHTML = h;
      el.drawer._imgs = imgs;
      el.drawer._return = document.activeElement;
      if (typeof el.drawer.showModal === 'function') el.drawer.showModal(); else el.drawer.setAttribute('open', '');
      el.drawerBody.scrollTop = 0;
      galGo(start, false);
      var track = el.drawer.querySelector('[data-gal-track]');
      if (track) {
        var gT;
        track.addEventListener('scroll', function () { clearTimeout(gT); gT = setTimeout(function () { galMark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60); }, { passive: true });
        track.addEventListener('keydown', function (e) {
          var cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (e.key === 'ArrowRight') { e.preventDefault(); galGo(Math.min(imgs.length - 1, cur + 1), true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); galGo(Math.max(0, cur - 1), true); }
        });
      }
      el.drawer.querySelector('.cawb-drawer__close').focus();
    }
    function closeDrawer() { if (typeof el.drawer.close === 'function') el.drawer.close(); else el.drawer.removeAttribute('open'); }
    el.drawer.addEventListener('close', function () { var r = el.drawer._return; if (r && document.contains(r)) r.focus({ preventScroll: true }); });
    el.drawer.addEventListener('click', function (e) {
      if (e.target === el.drawer) return closeDrawer(); // backdrop
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-close')) return closeDrawer();
      if (b.hasAttribute('data-gal')) return galGo(Number(b.getAttribute('data-gal')), true);
      if (b.hasAttribute('data-pick')) {
        var i = Number(b.getAttribute('data-for')), h = b.getAttribute('data-pick');
        el.drawer._return = null; closeDrawer();
        S.tab = 'shelf-' + i;
        chooseShelf(i, h, true);
      }
    });

    // ---------------------------------------------------------------- basket (v1 pipeline)
    function buildItems() {
      var items = lines().map(function (l) {
        var item = { id: Number(l.v.id), quantity: l.qty };
        if (l.props) item.properties = l.props;
        return item;
      });
      return items; // route order
    }
    function findProductByVariant(id) {
      for (var i = 0; i < P.length; i++) if (P[i].variants.some(function (v) { return Number(v.id) === Number(id); })) return P[i];
      return null;
    }
    async function addToCart(btn) {
      if (adding) return;
      var items = buildItems();
      if (!items.length) return;
      adding = true;
      btn.setAttribute('aria-busy', 'true');
      rootEl.querySelectorAll('[data-addall]').forEach(function (x) { x.setAttribute('aria-busy', 'true'); x.textContent = 'Adding…'; });
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      var sectionsUrl = window.location.pathname;
      var before = null;
      try { before = qtyByVariant(await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json()); } catch (e) { before = null; }
      var ok = false, result = 'error';
      try {
        var res = await fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: sectionsToBundle, sections_url: sectionsUrl })
        });
        var cartJson, sectionsHtml;
        if (res.ok) {
          ok = true;
          var addJson = await res.json();
          sectionsHtml = addJson.sections;
          cartJson = await (await fetch(root() + 'cart.js')).json();
          announce('Added to basket.');
          result = 'ok';
        } else {
          var errJson = null;
          try { errJson = await res.json(); } catch (e) { errJson = null; }
          var upd = await fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: {}, sections: sectionsToBundle, sections_url: sectionsUrl })
          });
          cartJson = await upd.json();
          sectionsHtml = cartJson.sections;
          result = reportShort(items, cartJson, before, res.status, errJson && (errJson.description || errJson.message));
        }
        if (cartJson) {
          cartJson.sections = sectionsHtml || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartJson } }));
        }
      } catch (err) {
        if (window.console) console.error('ca-wall-builder: add failed', err);
        problem('Something went wrong adding these parts. Please try again.');
      } finally {
        // shared with the #150 PDP: result = ok / partial / error (a many-line add can half-fail); `idea` kept as before
        track('ca_wall_builder_add', { currency: 'GBP', value: Math.round(totals().cents) / 100, result: result,
          parts: items.reduce(function (t, i) { return t + i.quantity; }, 0), lines: items.length, idea: S.idea || '', idea_id: S.idea || '',
          shelves: S.shelves.length, steps: S.steps.length });
        if (result === 'ok') stage('added');
        adding = false;
        S.added = ok;
        rootEl.querySelectorAll('[data-addall]').forEach(function (b2) {
          b2.removeAttribute('aria-busy');
          b2.textContent = ok ? 'View basket' : 'Add all to basket';
          b2.classList.toggle('is-added', ok);
        });
      }
    }
    function openBasket() {
      var d = document.getElementById('cart-drawer');
      if (d && typeof d.show === 'function') d.show();
      else window.location.href = root() + 'cart';
    }
    // Same semantics as the Alto builder: only a 422 is a stock refusal; otherwise never word it as one.
    // returns the tracking result: 'partial' when some parts landed, else 'error'
    function reportShort(items, cartJson, before, status, reason) {
      if (status !== 422) { problem('Something went wrong adding these parts. Please try again, or check your basket.'); return 'error'; }
      var why = typeof reason === 'string' ? reason.trim() : '';
      if (!before || !cartJson || !Array.isArray(cartJson.items)) { problem((why ? why + ' ' : 'Some parts could not be added. ') + 'Please check your basket.'); return 'error'; }
      var after = qtyByVariant(cartJson), any = false, short = [];
      items.forEach(function (req) {
        var landed = Math.max(0, (after.get(req.id) || 0) - (before.get(req.id) || 0));
        if (landed > 0) any = true;
        var pr = findProductByVariant(req.id);
        if (landed < req.quantity) short.push(landed + ' of ' + req.quantity + ' ' + (pr ? pr.name : 'parts'));
      });
      if (!any) { problem((why || 'These parts could not be added.') + ' Nothing was added to your basket.'); return 'error'; }
      problem(short.length ? 'Only ' + short.join('; ') + ' could be added.' + (why ? ' ' + why : '') : 'Please check your basket.');
      return 'partial';
    }

    // ---------------------------------------------------------------- events
    rootEl.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || el.drawer.contains(b)) return;
      if (b.hasAttribute('data-cawb-idea')) { startOnce('idea', b.getAttribute('data-cawb-idea')); applyIdea(b.getAttribute('data-cawb-idea')); if (el.confirm.hidden) scrollToPlanner(); return; }
      if (b.hasAttribute('data-cawb-blank')) { startOnce('blank'); applyIdea('blank'); if (el.confirm.hidden) scrollToPlanner(); return; }
      if (b.hasAttribute('data-cawb-confirm-yes')) { var pid = pendingIdea; if (pid) { applyIdea(pid, true); scrollToPlanner(); focusTab(); } return; }
      if (b.hasAttribute('data-cawb-confirm-no')) {
        var asked = pendingIdea === 'blank' ? el.blank : (IDEAS.filter(function (x) { return x.id === pendingIdea; })[0] || {}).el;
        hideConfirm(); announce('Your wall is unchanged.');
        if (asked) asked.focus({ preventScroll: true }); // back on the card that asked
        return;
      }
      if (b.hasAttribute('data-tab') && b.closest('.cawb-chips')) {
        var ct = b.getAttribute('data-tab'); goTab(ct, false);
        var cb = el.panels.querySelector('.cawb-chips [data-tab="' + ct + '"]'); if (cb) cb.focus({ preventScroll: true });
        return;
      }
      if (b.hasAttribute('data-tab')) { var hadFocus = document.activeElement === b; return goTab(b.getAttribute('data-tab'), hadFocus); }
      if (b.hasAttribute('data-go-review')) return goTab('review', false);
      if (b.hasAttribute('data-add-steps')) {
        startOnce('steps');
        // the panel-foot "Next: choose steps" also goes back to the top of the selections (review 7)
        var foot = b.hasAttribute('data-next');
        if (b.hasAttribute('data-colour-next')) S.open[S.tab] = null;   // v19: the colour row's Next closes its row, as before
        goTab('steps', !foot);
        if (foot) { var stp = document.getElementById('cawb-tab-steps'); if (stp) stp.focus({ preventScroll: true }); }
        return announce('Choose which steps and how many.');
      }
      if (b.hasAttribute('data-add-shelf')) {
        if (S.shelves.length >= MAX_SHELVES) return;
        startOnce('add_shelf');
        markDirty();
        S.shelves.push(blankShelf());
        var nid = 'shelf-' + (S.shelves.length - 1);
        delete S.open[nid];
        goTab(nid, true);
        return announce('Shelf ' + S.shelves.length + ' added. Choose a shelf' + (S.shelves.length > 1 ? ', or copy Shelf 1.' : '.'));
      }
      if (b.hasAttribute('data-remove')) {
        var ri = Number(b.getAttribute('data-remove'));
        var snap = { shelves: S.shelves.slice(), open: S.open, tab: S.tab, last: S.lastShelf, dirty: S.dirty, added: S.added };
        track('cawb_remove', { shelf_index: ri });
        markDirty();
        S.shelves.splice(ri, 1);
        S.open = {};
        if (S.shelves.length) goTab('shelf-' + Math.max(0, ri - 1), true);
        else { S.tab = S.steps.length ? 'steps' : 'none'; render(); }
        return toast('Shelf ' + (ri + 1) + ' removed.', function () {
          S.shelves = snap.shelves; S.open = snap.open; S.lastShelf = snap.last; S.dirty = snap.dirty; S.added = snap.added;
          track('cawb_undo', { shelf_index: ri });
          goTab(snap.tab, true);
          announce('Shelf ' + (ri + 1) + ' is back.');
        });
      }
      if (b.hasAttribute('data-undo')) { var uf = undoFn; undoFn = null; el.toast.hidden = true; if (uf) uf(); return; }
      if (b.hasAttribute('data-open-row')) {
        var oid = S.tab, ok2 = b.getAttribute('data-open-row');
        S.open[oid] = ok2; focusAfter = 'cawb-rowbtn-' + oid + '-' + rk(ok2); render(); scrollRow(oid, ok2); return;
      }
      if (b.hasAttribute('data-colour-next')) {
        var cid = S.tab, ck = b.getAttribute('data-colour-next');
        if (ck) { S.open[cid] = ck; focusAfter = 'cawb-rowbtn-' + cid + '-' + rk(ck); render(); scrollRow(cid, ck); return; }
        S.open[cid] = null;
        var na = nextAction(cid);
        return goTab(na.id, false, na.row || undefined);
      }
      // #104 review 6 (Martin 2026-10-21): Reset selections (named in review 7) clears the whole wall; Undo (not an
      // "are you sure?") puts it back
      if (b.hasAttribute('data-cawb-reset')) {
        if (isEmpty()) return;
        var keep = JSON.stringify({ shelves: S.shelves, steps: S.steps, stepShared: S.stepShared, perStep: S.perStep, tab: S.tab, open: S.open,
          idea: S.idea, dirty: S.dirty, added: S.added, lastShelf: S.lastShelf });
        track('cawb_reset', { shelves: S.shelves.length, steps: S.steps.length });
        clarity('cawb_stage', 'reset');
        applyIdea('blank', true);
        S.idea = null; S.lastShelf = null; render();
        if (el.planner) { var pt = el.planner.getBoundingClientRect().top; if (pt < 0) window.scrollTo({ top: window.scrollY + pt - topOffset() + 4 }); }
        return toast('Your selections have been reset.', function () {
          Object.assign(S, JSON.parse(keep));
          track('cawb_undo', { undo_of: 'reset' });
          render();
          focusTab();
          announce('Your wall is back.');
        });
      }
      if (b.hasAttribute('data-next')) return goTab(b.getAttribute('data-next'), false, b.getAttribute('data-nextrow') || undefined);
      if (b.hasAttribute('data-car-prev')) return carMove(b, -1);
      if (b.hasAttribute('data-car-next')) return carMove(b, 1);
      if (b.hasAttribute('data-copy')) { track('cawb_copy', { shelf_index: Number(b.getAttribute('data-copy')) }); return copyFromFirst(Number(b.getAttribute('data-copy'))); }
      if (b.hasAttribute('data-details')) track('cawb_details', { product_handle: b.getAttribute('data-details') });
      if (b.hasAttribute('data-details')) return openDrawer(b.getAttribute('data-details'), b.hasAttribute('data-for') ? Number(b.getAttribute('data-for')) : null);
      if (b.hasAttribute('data-row')) {
        var key = b.getAttribute('data-row'), id = S.tab;
        S.open[id] = S.open[id] === key ? null : key;
        focusAfter = b.id;
        render();
        // a phone opening the colour row: bring it to the top, so the big picture AND the colours are on screen
        if (S.open[id] === key && isPicKey(key) && /^shelf-/.test(id) && window.innerWidth < 750) scrollRow(id, key);
        return;
      }
      if (b.hasAttribute('data-qty')) {
        var h = b.getAttribute('data-h'), dq = b.getAttribute('data-qty');
        startOnce('steps');
        markDirty();
        setStepCount(h, stepCount(h) + Number(dq));
        if (S.tab === 'none') S.tab = 'steps';
        render();
        var again = el.panels.querySelector('[data-qty="' + dq + '"][data-h="' + h + '"]');
        if (again && !again.disabled) again.focus({ preventScroll: true });
        else { var other = el.panels.querySelector('[data-h="' + h + '"]:not([disabled])'); if (other) other.focus({ preventScroll: true }); }
        return announce(stepCount(h) + ' ' + stepByHandle[h].name + (stepCount(h) === 1 ? '' : 's') + '. ' + S.steps.length + ' steps in total.');
      }
      if (b.hasAttribute('data-goto')) {
        var row = b.getAttribute('data-gorow');
        if (b.getAttribute('data-goto') === 'none') { S.tab = 'none'; render(); return; }
        return goTab(b.getAttribute('data-goto'), false, row || undefined);
      }
      if (b.hasAttribute('data-addall')) {
        // #104 final review: once the wall is in the basket the button opens it; a second tap used to add it all again
        if (S.added) return openBasket();
        if (isEmpty()) return;
        if (todoList().length) {
          track('cawb_add_blocked', { choices_left: todoList().length, first_open: firstOpenSlug() });
          stage('add_blocked');
          if (S.tab !== 'review') goTab('review', false);
          var td = document.getElementById('cawb-todo');
          if (td) { td.focus({ preventScroll: true }); td.scrollIntoView({ block: 'center' }); }
          return announce('Some choices are still open. They are listed above the parts.');
        }
        addToCart(b);
      }
    });
    // scroll does not bubble: listen in the capture phase for any carousel's own scroll
    rootEl.addEventListener('scroll', function (e) { if (e.target.matches && e.target.matches('[data-car]')) carState(e.target); }, true);
    rootEl.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type=radio][data-axis="shelf"]')) return chooseShelf(Number(t.getAttribute('data-shelf')), t.value, lastPointer);
      if (t.matches('input[type=radio][data-shelf]')) return chooseShelfAxis(Number(t.getAttribute('data-shelf')), t.getAttribute('data-axis'), t.value, lastPointer);
      if (t.matches('input[type=radio][data-steph]')) return chooseStepAxis(t.getAttribute('data-steph'), t.getAttribute('data-axis'), t.value, lastPointer);
      if (t.matches('[data-perstep]')) {
        markDirty();
        S.perStep = t.checked;
        S.steps.forEach(function (st) { st.ui = Object.assign({}, sharedFor(st.handle).ui, S.perStep ? st.ui : {}); });
        focusAfter = null; render();
        var cb = el.panels.querySelector('[data-perstep]'); if (cb) cb.focus({ preventScroll: true });
        return announce(S.perStep ? 'Each step now has its own colour choices.' : 'All steps share one set of colours.');
      }
      if (t.matches('select[data-stepi]')) {
        markDirty();
        var st = S.steps[Number(t.getAttribute('data-stepi'))];
        st.ui[t.getAttribute('data-axis')] = t.value || undefined;
        var sel = { i: t.getAttribute('data-stepi'), a: t.getAttribute('data-axis') };
        render();
        var s2 = el.panels.querySelector('select[data-stepi="' + sel.i + '"][data-axis="' + sel.a + '"]'); if (s2) s2.focus({ preventScroll: true });
      }
    });
    // Enter on a focused option = choose it and move on (keyboard equivalent of the tap auto-advance)
    rootEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('input[type=radio]')) return;
      e.preventDefault();
      var t = e.target;
      t.checked = true;
      if (t.getAttribute('data-axis') === 'shelf') {
        var i = Number(t.getAttribute('data-shelf'));
        if (S.shelves[i].handle === t.value) {
          var rf = rowsFor(S.shelves[i]);
          S.open['shelf-' + i] = nextOpen('shelf-' + i, rf.rows, Object.assign({ shelf: true }, S.shelves[i].done), 'shelf');
          focusAfter = S.open['shelf-' + i] ? 'cawb-rowbtn-shelf-' + i + '-' + rk(S.open['shelf-' + i]) : null;
          render();
        } else chooseShelf(i, t.value, true);
        return;
      }
      if (t.hasAttribute('data-shelf')) return chooseShelfAxis(Number(t.getAttribute('data-shelf')), t.getAttribute('data-axis'), t.value, true);
      if (t.hasAttribute('data-steph')) return chooseStepAxis(t.getAttribute('data-steph'), t.getAttribute('data-axis'), t.value, true);
    });
    var rT, wasCompact = compact();
    window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () {
      if (compact() !== wasCompact) { wasCompact = compact(); render(); }
      drawWall(); rootEl.style.setProperty('--cawb-strip-h', stripH() + 'px');
    }, 80); });

    // ---------------------------------------------------------------- landing: a TRUE blank wall, no path chosen;
    // deep links: ?idea=<id> (Pinterest/press), and v1's ?shelf=<handle>&variant=<id>&steps=<n>
    applyIdea('blank', true);
    S.idea = null;
    var q = new URLSearchParams(window.location.search);
    var qIdea = q.get('idea');
    var qShelf = q.get('shelf');
    var entry = 'fresh';
    if (qIdea && IDEAS.some(function (x) { return x.id === qIdea; })) { applyIdea(qIdea, true); entry = 'idea_link'; }
    else if (qShelf && eng[qShelf] && eng[qShelf].role === 'shelf') {
      entry = 'shelf_link';
      var p0 = byHandle[qShelf], vq = q.get('variant');
      var v0 = p0.variants.filter(function (v) { return String(v.id) === String(vq); })[0];
      var sh0 = v0 ? { handle: qShelf, ui: uiOfVariant(p0, v0), done: {} } : presetShelf(qShelf);
      if (v0) {
        if (p0.ca_type === 'cat shelf') sh0.ui['Base Fabric'] = R.PROPERTY_DEFAULTS['Base Fabric'];
        rowsFor(sh0).rows.forEach(function (r) { if (r.key !== 'shelf') sh0.done[r.key] = true; });
      }
      S.shelves = [sh0];
      var ns = parseInt(q.get('steps'), 10);
      presetSteps(isNaN(ns) ? R.CONSTANTS.DEFAULT_STEPS : Math.max(0, Math.min(MAX_STEPS, ns)));
      S.tab = 'shelf-0';
      render();
    }
    else if (loadWall()) entry = 'restored';
    canSave = true;
    // #104 final review: a deep link is used once. Save the wall it built and take it out of the address (keeping any
    // other parameters), so a refresh or Back brings back the shopper's own changes, not the link's wall again.
    if (entry === 'idea_link' || entry === 'shelf_link') {
      saveWall();
      try {
        ['idea', 'shelf', 'variant', 'steps'].forEach(function (k) { q.delete(k); });
        var qs = q.toString();
        history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      } catch (e) { /* the address is only tidied; the wall works without it */ }
    }
    // tracking starts here: what the landing already completed is not the shopper's progress on this visit
    S.shelves.forEach(function (sh) { if (shelfComplete(sh)) fired[doneKey(sh)] = true; });
    stepsSent = S.steps.length; lastTab = S.tab;
    tracking = true;
    track('cawb_view', { entry: entry, restored_pieces: entry === 'restored' ? S.shelves.length + S.steps.length : 0 });
    clarity('dpc_surface', 'wall_builder');
    stage('view');
    renderIdeas(); renderBar();

    // test hooks for the cart-free probe (read-only views of the state)
    window.__cawb = {
      state: function () { return JSON.parse(JSON.stringify({ shelves: S.shelves, steps: S.steps, idea: S.idea, dirty: S.dirty, tab: S.tab })); },
      totals: totals, todo: function () { return isEmpty() ? [] : todoList(); }, plan: function () { return lastPlan ? JSON.parse(JSON.stringify(lastPlan)) : null; },
      lines: function () { return lines().map(function (l) { return { handle: l.p.handle, id: l.v.id, title: l.v.title, qty: l.qty, price: l.v.price, props: l.props }; }); }
    };
    rootEl.classList.add('is-ready');
    drawWall(); renderBar();
    document.dispatchEvent(new CustomEvent('cawb:ready'));
    if (window.ResizeObserver) { var lastW = 0; new ResizeObserver(function () { var w = el.stage.clientWidth; if (w && Math.abs(w - lastW) > 1) { lastW = w; drawWall(); } }).observe(el.stage);
      // the phone strip's height (drawing + note) decides where the sticky step bar sits: keep it exact as fonts load / text wraps
      new ResizeObserver(function () { rootEl.style.setProperty('--cawb-strip-h', stripH() + 'px'); }).observe(el.wall); }
  }

  // #104 redesign: the in-page nav sticks under the header for the WHOLE page (the sections that follow are separate
  // Shopify sections, so CSS sticky would stop at the end of this one). Its wrapper keeps its height, so fixing it never
  // moves the page. The link for the section in view is marked aria-current. Independent of the builder: it runs even if
  // the builder fails to initialise.
  function bootNav() {
    var nav = document.querySelector('[data-cawb-nav]');
    if (!nav) return;
    var wrap = nav.parentElement, links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]')), ticking = false;
    function update() {
      ticking = false;
      var hh = headerH(), stuck = wrap.getBoundingClientRect().top < hh;
      nav.classList.toggle('is-stuck', stuck);
      document.documentElement.style.setProperty('--cawb-nav-h', nav.classList.contains('is-stuck') ? nav.offsetHeight + 'px' : '0px');
      var line = hh + nav.offsetHeight + 24, cur = null;
      // a link the phone menu hides (Enrichment ideas, 2026-10-21) never takes the mark: the one before it keeps it
      links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (a.getClientRects().length && t && t.getClientRects().length && t.getBoundingClientRect().top <= line) cur = a; });
      links.forEach(function (a) { if (a === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      if (cur && stuck && cur.offsetParent) { var inner = cur.parentElement; if (inner.scrollWidth > inner.clientWidth) inner.scrollLeft = Math.max(0, cur.offsetLeft - 16); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    document.addEventListener('cawb:ready', onScroll); // the builder's sections only get a box once it is ready
    update();
  }

  // Fail closed: if anything throws, the builder stays hidden (CSS, no .is-ready) and the fallback links stay visible.
  function boot() {
    try { bootNav(); } catch (err) { if (window.console) console.error('ca-wall-builder: nav failed', err); }
    var rootEl = document.querySelector('ca-wall-builder');
    if (!rootEl) return;
    try { init(rootEl); } catch (err) {
      rootEl.classList.add('is-failed'); // releases the space held while it started (CSS), so the fallback shows now
      sendError();
      if (window.console) console.error('ca-wall-builder: init failed', err);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
